import React, { lazy, useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Service
import ItemService from "../../../../services/customer_appCommonService";
import Constants from "../../../../common/CustomerConstants";

//Components
import Layout from "../../../../Layout/Layout";
import StatusCustomReport from "./StatusCustomReport";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { loadCustomerLedgers } from "../../../../redux/feature/reportSlice";
import { formatDate } from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";
import { addInvoiceID } from "../../../../redux/feature/customer_app/preSalesSlice";
import {
  bankStatements,
  cashExpensesNr,
  getLedgerList,
  purchaseNr,
  updateLedgerFilter,
  updateStep,
} from "../../../../redux/feature/customer_app/customerSlice";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { InputField } from "../../../../Components/formElements/InputField";
import { useReactToPrint } from "react-to-print";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
// import { toDate } from "validator";
import toast from "react-hot-toast";

const CustomReportV2 = () => {
  localStorage.setItem("menu", "Ledger");
  localStorage.setItem("submenu", "");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;

  let reportState = useSelector((state) => state?.report);

  let ledgerFilters = useSelector(
    (state) => state.customer.ledgers.ledgersFilter,
  );
  let tableData = useSelector((state) => state.customer.ledgers.data);

  const [getOpeningValue, setOpeningValue] = useState();
  const currentYearForData = new Date().getFullYear();

  // console.log(">>tableData", tableData);
  // console.log(">>ledgerFilters", ledgerFilters);
  // const ledgerData = useSelector((state) => state.customer.ledgers.data) || [];
  // eslint-disable-next-line
  const hasTableData = Array.isArray(tableData) && tableData.length > 0;
  // console.log(">>tableData",tableData)
  const subtotal = tableData.reduce(
    (acc, entry) => {
      const items = entry?.items;

      if (Array.isArray(items)) {
        items.forEach((item) => {
          acc.debit += Number(item?.debitAmount || 0);
          acc.credit += Number(item?.creditAmount || 0);
          acc.gross += Number(item?.grossValue || 0);
        });
      } else if (items && typeof items === "object") {
        acc.debit += Number(items.debitAmount || 0);
        acc.credit += Number(items.creditAmount || 0);
        acc.gross += Number(items.grossValue || 0);
      }

      return acc;
    },
    { debit: 0, credit: 0, gross: 0 },
  );
  const closingValue = Number(
    (parseFloat(subtotal.debit) - parseFloat(subtotal.credit)).toFixed(0),
  );
  //rounded value
  // function roundToIntWithTwoDecimals(value) {
  //   if (value === null || value === undefined) return "";

  //   const str = String(value);

  //   let intPart = str;
  //   let decPart = "";

  //   if (str.includes(".")) {
  //     [intPart, decPart] = str.split(".");
  //   }

  //   const roundDigit = decPart?.[0] >= "5" ? 1 : 0;

  //   let intArr = intPart.split("").map(Number);
  //   let carry = roundDigit;

  //   for (let i = intArr.length - 1; i >= 0 && carry; i--) {
  //     const sum = intArr[i] + carry;
  //     intArr[i] = sum % 10;
  //     carry = sum >= 10 ? 1 : 0;
  //   }

  //   if (carry) intArr.unshift(1);

  //   return `${intArr.join("")}`;//  return `${intArr.join("")}.00`; to show decimal value .00

  // }

  function roundToIntWithTwoDecimals(value) {
    const num = Number(value);

    // ⛔ protect against NaN, null, undefined, empty
    if (!Number.isFinite(num)) return "0";

    const rounded = Math.round(num);

    return String(rounded); // or `${rounded}.00`
  }

  const toNumber = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };

  const closingBalanceValue =
    toNumber(getOpeningValue) -
    toNumber(subtotal.debit) +
    toNumber(subtotal.credit);
  // const closingBalanceValue = toNumber(subtotal.debit)-toNumber(subtotal.credit);

  const openingRow = {
    isSpecialRow: true,
    rowType: "opening",
    createdAt: "01-Oct-25",
    transactionType: "Opening Balance",
    documentNumber: "",
    voucherNumber: "",
    openingbalance: roundToIntWithTwoDecimals(getOpeningValue) ?? 0,
    items: {
      debitAmount: "",
      creditAmount: 0,
      grossValue: 0,
    },
    remarks: "",
  };

  const subtotalRow = {
    isSpecialRow: true,
    rowType: "subTotal",
    transactionType: "subTotal",
    documentNumber: "",
    voucherNumber: "",
    totalDebitAmount: roundToIntWithTwoDecimals(subtotal.debit),
    totalCreditAmount: roundToIntWithTwoDecimals(subtotal.credit),
    totalGrossValue: roundToIntWithTwoDecimals(subtotal.gross),
    items: {
      debitAmount: "",
      creditAmount: "",
      grossValue: "",
    },
    remarks: "",
  };
  // console.log(">>subtotalRow", subtotalRow);
  const totalRow = {
    isSpecialRow: true,
    rowType: "total",
    transactionType: "Total",
    documentNumber: "",
    voucherNumber: "",
    items: {
      debitAmount: "",
      creditAmount: "",
    },
    remarks: "",
  };

  // console.log(">>closingBalanceValue",closingBalanceValue)
  const closingRow = {
    isSpecialRow: true,
    rowType: "closing",
    transactionType: "Closing Balance",
    documentNumber: "",
    voucherNumber: "",
    closingBlance: roundToIntWithTwoDecimals(closingBalanceValue),
    items: {
      debitAmount: closingValue,
      creditAmount: "",
    },
    remarks: "",
  };

  // console.log(">>closingRow",closingRow)
  const tableDataDynamic = [
    openingRow,
    ...tableData,
    subtotalRow,
    closingRow,
    totalRow,
  ];
  const salesLedgerTableDataDynamic = [...tableData, subtotalRow];
  const purchaseLedgerTableDataDynamic = [...tableData, subtotalRow];
  // const tableDataDynamic = hasTableData
  // ? [openingRow, ...tableData, subtotalRow, closingRow, totalRow]
  // : [];

  const loading = useSelector((state) => state.customer.ledgers.status);

  const ledgersSteps = useSelector((state) => state.customer.ledgers.step);

  const now = new Date();
  const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11, so add 1
  const currentYear = now.getFullYear();

  let reportDatapagination = useSelector(
    (state) => state?.customer?.ledgers?.pagination,
  );

  const [getcashBankAlldetails, setcashBankAlldetails] = useState([]);

  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "STOCK") {
      const MaterialListByCompany = {
        queryName: "MaterialListByCompany",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode,
        page: 1,
        per_page: 10,
      };
      dispatch(getLedgerList(MaterialListByCompany));
    } else if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      const obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };

      dispatch(getLedgerList(obj));
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      const obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };

      dispatch(getLedgerList(obj));
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      let obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
      dispatch(getLedgerList(obj));
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      const SpecificMaterialByCompanyAndCurYearMonthly = {
        queryName: "SpecificMaterialByCompanyAndCurYearMonthly",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode,
        materialCode: ledgerFilters[0]?.materialCode,
        page: 1,
        per_page: 10,
      };

      dispatch(getLedgerList(SpecificMaterialByCompanyAndCurYearMonthly));
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      let obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
      // let obj = {
      //   queryName: "Customer_Ledger_By_Customer_List",
      //   module: "",
      //   companyCode: "",
      //   customerCode: ledgerFilters[0]?.customerCode,
      //   year: ledgerFilters[0]?.year,
      //   month: ledgerFilters[0]?.month,
      //   page: 1,
      //   per_page: 10,
      //   rowFilter: {
      //     $and: [
      //       {
      //         companyCodeDesc: ledgerFilters[0]?.description,
      //       },
      //     ],
      //   },
      //   timeZone: "Asia/Calcutta",
      // };

      dispatch(getLedgerList(obj));
    } else if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") {
      let obj;

      if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
        obj = {
          queryName: "Customer_Ledger_By_Customer_List",
          module: "",
          companyCode: "",
          customerCode: ledgerFilters[0]?.customerCode,
          year: ledgerFilters[0]?.year,
          month: ledgerFilters[0]?.month,
          page: 1,
          per_page: 10,
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
              },
            ],
          },
          timeZone: "Asia/Calcutta",
        };
      } else {
        obj = {
          queryName: ledgerFilters[0]?.ledgersQuerName,
          page: 1,
          per_page: 10,
          searchTerm: "",
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
                month: ledgerFilters[0]?.month,
                year: ledgerFilters[0]?.year,
              },
            ],
          },
        };
      }

      dispatch(getLedgerList(obj));
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      const SpecificMaterialByCompanyDaywise = {
        queryName: "SpecificMaterialByCompanyDaywise",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode,
        materialCode: ledgerFilters[0]?.materialCode,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: 10,
      };
      dispatch(getLedgerList(SpecificMaterialByCompanyDaywise));
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      const Customer_BankAndExpenses_List = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(Customer_BankAndExpenses_List));
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      const Customer_BankAndExpenses_List = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        // bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(Customer_BankAndExpenses_List));
    }
  }, [ledgersSteps, ledgerFilters, dispatch, currentMonth, currentYear]);

  const [getToatalCalucation, setToatalCalucation] = useState([]);

  const toatalCalucation = async () => {
    let obj = {};
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      obj = {
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      obj = {
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: reportDatapagination?.total,
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: reportDatapagination?.total,
      };
    }

    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          let totalDebitAmount = item.data
            .reduce((acc, curr) => acc + (curr.items?.debitAmount || 0), 0)
            .toFixed(2);

          // ✅ store object instead of array
          setToatalCalucation([{ totalDebitAmount: Number(totalDebitAmount) }]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          let totalCreditAmount = item.data
            .reduce((acc, curr) => acc + (curr.items?.creditAmount || 0), 0)
            .toFixed(2);

          // ✅ store object instead of array
          setToatalCalucation([
            { totalCreditAmount: Number(totalCreditAmount) },
          ]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          let totalCreditAmount = item.data
            .reduce((acc, curr) => acc + (curr.items?.creditAmount || 0), 0)
            .toFixed(2);

          // ✅ store object instead of array
          setToatalCalucation([
            { totalCreditAmount: Number(totalCreditAmount) },
          ]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          let totalCreditAmount = item.data
            .reduce((acc, curr) => acc + (curr.items?.creditAmount || 0), 0)
            .toFixed(2);

          // ✅ store object instead of array
          setToatalCalucation([
            { totalCreditAmount: Number(totalCreditAmount) },
          ]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          // console.log(">>item",item)
          let totalDebitAmount = item.data
            .reduce((acc, curr) => acc + (curr.items[0]?.debitAmount || 0), 0)
            .toFixed(2);
          let totalCreditAmount = item.data
            .reduce((acc, curr) => acc + (curr.items[0]?.creditAmount || 0), 0)
            .toFixed(2);
          // ✅ store object instead of array
          setToatalCalucation([
            { totalDebitAmount: Number(totalDebitAmount) },
            { totalCreditAmount: Number(totalCreditAmount) },
          ]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      await ItemService.generateCustomerQuery(obj).then((item) => {
        // console.log("item", item);
        if (item?.status === 200) {
          let totalDebitAmount = item.data
            .reduce((acc, curr) => acc + (curr.items[0]?.debitAmount || 0), 0)
            .toFixed(2);
          let totalCreditAmount = item.data
            .reduce((acc, curr) => acc + (curr.items[0]?.creditAmount || 0), 0)
            .toFixed(2);
          // ✅ store object instead of array
          setToatalCalucation([
            { totalDebitAmount: Number(totalDebitAmount) },
            { totalCreditAmount: Number(totalCreditAmount) },
          ]);
        } else {
          setToatalCalucation([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    }
  };

  useEffect(() => {
    toatalCalucation();
    // eslint-disable-next-line
  }, [ledgersSteps, ledgerFilters, reportDatapagination]); // ✅ added dependencies
  // eslint-disable-next-line
  const [getCashData, setCashData] = useState([]);

  // useEffect(() => {
  //   // if (ledgersSteps === 5 && ledgerFilters?.reportType === "CASH_BANK") {
  //   //   // console.log(">>ledgerFilters?.companyCode",ledgerFilters[0]?.companyCode)
  //   //   const filteredTableData = tableData.filter(
  //   //     (item) => item.companyCode === ledgerFilters[0]?.companyCode
  //   //   );
  //   //   setCashData(filteredTableData);
  //   // }
  //   // const filteredTableData = tableData.filter(
  //   //     (item) => item.companyCode === ledgerFilters[0]?.companyCode
  //   //   );
  //   if (ledgerFilters[0]?.transactionType === "EK") {
  //     // const debitData = tableData.filter((row) => row?.type === "DEBIT");
  //     setCashData(tableData);
  //   } else {
  //     setCashData(tableData);
  //   }
  // }, [ledgersSteps, ledgerFilters, tableData]);

  // useEffect(() => {
  //   if (ledgerFilters[0]?.transactionType === "EK") {
  //     const filteredData = tableData.filter((row) => {
  //       if (
  //         row?.adminConfirmation === "Partial Amount" ||
  //         row?.adminConfirmation === "Full Amount"
  //       ) {
  //         return row.type === "CREDIT";
  //       }
  //       return row.type === "DEBIT";
  //     });
  //     setCashData(filteredData);
  //   } else {
  //     setCashData(tableData);
  //   }
  // }, [ledgersSteps, ledgerFilters, tableData]);
  useEffect(() => {
    if (ledgerFilters[0]?.transactionType === "EK") {
      // Filter only EK transactions, include both DEBIT and CREDIT
      // const ekData = tableData.filter(
      //   (row) => row?.type === "DEBIT" || row?.type === "CREDIT"
      // );

      const filtered = tableData.filter(
        (item) =>
          (item.transaction === "Payment" && item.transactionType === "EK") ||
          item.cashType === "CR",
      );
      setCashData(filtered);
    } else {
      // Show all data for other transaction types
      setCashData(tableData);
    }
  }, [ledgersSteps, ledgerFilters, tableData]);

  const reports = [
    {
      id: 1,
      name: "Stock Summary",
      code: "STOCK",
    },
    {
      id: 2,
      name: "Sales Register",
      code: "SALES",
      year: currentYear,
      month: currentMonth,
    },
    {
      id: 3,
      name: "Purchase Register",
      code: "PURCHASE",
      year: currentYear,
      month: currentMonth,
    },
    {
      id: 4,
      name: "Ledger",
      code: "LEDGER",
    },
    {
      id: 5,
      name: "Cash/Bank",
      code: "CASH_BANK",
    },
    {
      id: 6,
      name: "Expense",
      code: "EXPENSE",
    },
  ];
  const ledgerOptions = [
    { id: 1, name: "RoundOff", code: "ROUNDOFF_LEDGER" },
    { id: 2, name: "Outward CGST 14%", code: "SALES_CGST_14_LEDGER" },
    { id: 3, name: "Outward SGST 14%", code: "SALES_SGST_14_LEDGER" },
    { id: 4, name: "Outward CGST 9%", code: "SALES_CGST_9_LEDGER" },
    { id: 5, name: "Outward SGST 9%", code: "SALES_SGST_9_LEDGER" },
    { id: 7, name: "Inward SGST 14%", code: "PURCHASE_SGST_14_LEDGER" },
    { id: 8, name: "Inward CGST 14%", code: "PURCHASE_CGST_14_LEDGER" },
    { id: 9, name: "Inward CGST 9%", code: "PURCHASE_CGST_9_LEDGER" },
    { id: 10, name: "Inward SGST 9%", code: "PURCHASE_SGST_9_LEDGER" },
    { id: 11, name: "Inward IGST", code: "PURCHASE_IGST_LEDGER" },
  ];

  const [getCustomer, setCustomer] = useState([]);

  const [getledgersColumn, SetledgersColumn] = useState([]);

  const [filterShow, setFilterShow] = useState(false);

  const [getDropdownData, setDropdownData] = useState("");

  const [getCompanyDetails, setCompanyDetails] = useState(null);

  const [formInputs, setFormInputs] = useState({});

  const [getDate, setDate] = useState({});


  const [getCompanyCode, setCompanyCode] = useState([]);

  const [isCardVisible, setCardVisible] = useState(true);

  const [getNewPerPage, setNewPerPage] = useState(10);

  const [getDisabelCustomer, setDisabelCustomer] = useState(true);

  //stock product details
  const productColumns = [
    {
      name: "Item",
      selector: (row) => row.materialLongText,
      cell: (row) => (
        <>
          <div className="table-data">
            <div className="company-body">
              <div
                onClick={() => handleProdcutClick(row)}
                className="company-item"
              >
                <span className="fw-bold cursor-pointer">
                  {row.materialLongText}
                </span>
              </div>{" "}
            </div>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-danger">Closing</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-danger">Quantity</span>
            <span className="fw-medium text-danger">Value</span>
          </div>
        </div>
      ),
      cell: (row) => {
        return (
          <div className="d-flex justify-content-around w-100">
            <span className="text-danger fw-bold pe-2">
              {row.closingBalance} {row?.uOM || "BAGS"}
            </span>
            <span className="text-danger fw-bold pe-2">
              {parseFloat(row?.totalBasicClosingBalance).toFixed(2) || "--"}
            </span>
          </div>
        );
      },
      sortable: false,
    },
  ];

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const customerDataDropdown = async () => {
    // let obj = {
    //   companyCode: "SSA",
    // };

    // await ItemService.getCustomersByCompany(obj).then((item) => {
    //   if (item?.status === 200) {
    //     setCustomer(item?.data);
    //   } else {
    //     setCustomer([]);
    //     console.log(">> Error: Loading getCustomers");
    //   }
    // });

    let obj = {
      queryName: "AllCustomers",
      page: 1,
      per_page: 10,
    };

    // await ItemService.generateCustomerQuery(obj).then((item) => {
    //   if (item?.status === 200) {
    //     setCustomer(item?.data);
    //   } else {
    //     setCustomer([]);
    //     console.log(">> Error: Loading getCustomers");
    //   }
    // });
    await ItemService.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        const transformed = item.data.map((cust) => ({
          id: cust.customerCode,
          name: cust.organisationName,
          desc: cust.organisationName,
          customerAddress: cust?.address + cust?.address2,
        }));
        setCustomer(transformed);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  useEffect(() => {
    customerDataDropdown();
  }, []);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);

    if (getDropdownData?.textCode === "customerCode") {
      if (getDropdownData?.status === true) {
        setDisabelCustomer(false);
      } else {
        setDisabelCustomer(true);
      }
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
        customerAddress: `${getDropdownData?.address || ""} ${
          getDropdownData?.address2 || ""
        }`.trim(),
      }));
    } else {
      setDisabelCustomer(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //stock month wise
  const stockMonthColumns = [
    // {
    //   name: "Month",
    //   selector: (row) => row.month,
    //   cell: (row) => (
    //     <>
    //       <div className="table-data">
    //         <div className="company-body">
    //           <div
    //             onClick={() => handleMonthClick(row)}
    //             className="company-item"
    //           >
    //             <span className="fw-bold">{row.month}</span>
    //           </div>{" "}
    //         </div>
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "300px",
    // },
    {
      name: "Month",
      selector: (row) => row.month,
      cell: (row) => {
        const monthIndex = parseInt(row.month) - 1;
        const displayMonth = monthNames[monthIndex] || row.month;

        return (
          <div className="table-data">
            <div className="company-body">
              <div
                onClick={() => handleMonthClick(row)}
                className="company-item"
              >
                <span className="fw-bold">{displayMonth}</span>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "300px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-primary">Inwards</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-primary">Quantity</span>
            <span className="fw-medium text-primary">Value</span>
          </div>
        </div>
      ),
      cell: (row) => (
        <div className="d-flex justify-content-around w-100">
          <div>
            {row.totalPoInwardQty ? (
              <>
                <span className="text-primary fw-bold pe-2">
                  {row.totalPoInwardQty}
                </span>
                <span className="text-primary fw-bold">
                  {row?.uOM || "BAGS"}
                </span>
              </>
            ) : (
              <span className="text-primary fw-bold">--</span>
            )}
          </div>
          <span className="text-primary fw-bold">
            {row.totalPoInwardNetValue || "--"}
          </span>
        </div>
      ),
      sortable: false,
      width: "300px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-success">Outwards</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-success">Quantity</span>
            <span className="fw-medium text-success">Value</span>
          </div>
        </div>
      ),
      cell: (row) => (
        <div className="d-flex justify-content-around w-100">
          <div>
            {row.totalPoOutwardQty ? (
              <>
                <span className="text-success fw-bold pe-2">
                  {row.totalPoOutwardQty}
                </span>
                <span className="text-success fw-bold fw-bold">
                  {row.uOM || "BAGS"}
                </span>
              </>
            ) : (
              <span className="text-success fw-bold fw-bold">--</span>
            )}
          </div>
          <span className="text-success fw-bold">
            {/* {row.totalPoOutwardNetValue || "--"} */}
            {parseFloat(row.totalPoInvBasicAmount).toFixed(2) || "--"}
          </span>
        </div>
      ),
      sortable: false,
      width: "300px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-danger">Closing</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-danger">Quantity</span>
            <span className="fw-medium text-danger">Value</span>
          </div>
        </div>
      ),
      cell: (row) => {
        return (
          <div className="d-flex justify-content-around w-100">
            <span className="text-danger fw-bold pe-2">
              {row.totalClosingBalance} {row?.uOM || "BAGS"}
            </span>
            <span className="text-danger fw-bold pe-2">
              {/* ₹
              {parseFloat(row?.totalPoInwardNetValue) -
                parseFloat(row?.totalPoOutwardNetValue).toFixed(2)} */}
              ₹
              {Number(
                parseFloat(row?.totalPoInwardNetValue || 0) -
                  parseFloat(row?.totalPoInvBasicAmount || 0),
              ).toFixed(2)}
            </span>
          </div>
        );
      },
      sortable: false,
      width: "300px",
    },
  ];
  //SALES_CGST_14_LEDGER
  const salesCgst14Ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">--</span>
        </div>
      ),
      width: "220px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-success">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {row?.totals?.cgstValue_14 || "--"}
          </span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //SALES_SGST_14_LEDGER
  const salesSgst14Ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">--</span>
        </div>
      ),
      width: "220px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-success">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {row?.totals?.sgstValue_14 || "--"}
          </span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //SALES_CGST_9_LEDGER
  const salesCgst9Ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">--</span>
        </div>
      ),
      width: "200px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-success">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {/* {row?.totals?.cgstValue_9.toFixed(2) || "--"} */}
            {row?.totals?.cgstValue_9
              ? Math.round(row.totals.cgstValue_9 * 100) / 100
              : "--"}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //SALES_SGST_9_LEDGER
  const salesSgst9Ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">--</span>
        </div>
      ),
      width: "200px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-success">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {/* {row?.totals?.sgstValue_9.toFixed(2) || "--"} */}
            {row?.totals?.sgstValue_9
              ? Math.round(row.totals.sgstValue_9 * 100) / 100
              : "--"}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //PURCHASE_SGST_14_LEDGER
  const purchaseSgst14ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">
            {" "}
            {row?.poTotals?.poSgstValue_14 || "--"}{" "}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      // name: "Credit (Output CGST @ 14%  )",
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-primary fw-bold">--</span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //PURCHASE_CGST_14_LEDGER
  const purchaseCgst14ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-success">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {" "}
            {row?.poTotals?.poCgstValue_14 || "--"}
          </span>
        </div>
      ),
      width: "200px",
    },
    {
      // name: "Credit (Output CGST @ 14%  )",
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-primary fw-bold">--</span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //PURCHASE_SGST_9_LEDGER
  const purchaseSgst9ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">
            {row?.poTotals?.poSgstValue_9 || "--"}
          </span>
        </div>
      ),
      width: "260px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-primary fw-bold">
            {/* {row?.poTotals?.poSgstValue_9 || "--"} */}
            --
          </span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //PURCHASE_IGST_LEDGER
  const purchaseCgst9ledgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "160px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-danger fw-bold">
            {row?.poTotals?.poCgstValue_9 || "--"}
          </span>
        </div>
      ),
      width: "260px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-primary fw-bold">
            {/* {row?.poTotals?.poTotalIgst || "--"} */} --
          </span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //RoundOff
  const roundOff = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span>{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Debit Round Off",
      cell: (row) => (
        <>
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row.poRoundOff ?? "--"}
            </span>
          </div>
        </>
      ),
      width: "140px",
    },
    {
      name: "Credit Round off",
      cell: (row) => (
        <div
          className="d-flex justify-content-center align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-success fw-bold">
            {/* {row.roundOff || "--"} */}
            {row.roundOff ?? "--"}
          </span>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //igstledgers
  const igstLedgers = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">{row.customerName}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   cell: (row) => (
    //     <>
    //       {
    //         <div className="card-body">
    //           <span className="bg-table-status bg-table-success-status px-4 mr-2">
    //             {row?.transaction}{" "}
    //           </span>
    //         </div>
    //       }
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Transaction",
      cell: (row) => (
        <>
          {row?.transaction === "Purchase" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                {row?.transaction}{" "}
              </span>
            </div>
          )}
        </>
      ),
      width: "160px",
    },
    {
      name: "Invoice Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row.documentNumber, row.transaction)
          }
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Debit (Output CGST @ 14% / 9%)",
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //         {row?.poTotals?.poTotalCgst || "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "260px",
    // },
    {
      // name: "Credit (Output IGST)",
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit (Output IGST)</span>
        </div>
      ),
      cell: (row) => (
        <div
          className="d-flex justify-content-end align-items-center w-100"
          style={{ textAlign: "right" }}
        >
          <span className="text-primary fw-bold">
            {row?.poTotals?.poTotalIgst || "--"}
          </span>
        </div>
      ),
      width: "220px",
    },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //customerLedger
  const customerLedger = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Transaction",
      cell: (row) => {
        if (row.isSpecialRow) return "";

        return (
          <>
            {row?.transactionType === "BK" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}
                </span>
              </div>
            ) : row?.transactionType === "PO" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  Purchase
                </span>
              </div>
            ) : row?.transactionType === "INV" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  Sales
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}
                </span>
              </div>
            )}
          </>
        );
      },

      width: "160px",
    },
    {
      name: "Transaction ID",
      id: "documentNumber",
      selector: (row) => row.documentNumber,

      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return <strong>Opening Balance</strong>;
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return <strong>Closing Balance</strong>;
        }

        if (row.isSpecialRow) return "";

        if (row?.transactionType === "BK") {
          return (
            <button
              className="btnInfo"
              onClick={() =>
                detailedPageInvoice(row.documentNumber, row.transactionType)
              }
            >
              {row.voucherNumber || "--"}{" "}
              {/* {row.documentNumber || "--"}{" "} */}
            </button>
          );
        } else if (row?.transactionType === "EK") {
          return (
            <button
              className="btnInfo"
              onClick={() =>
                detailedPageInvoice(row.documentNumber, row.transactionType)
              }
            >
              {/* {row.voucherNumber || "--"}{" "} */}
              {row.voucherNumber || "--"}{" "}
            </button>
          );
        } else if (row?.transactionType === "PO") {
          return (
            <button
              className="btnInfo"
              onClick={() =>
                detailedPageInvoice(row.documentNumber, row.transactionType)
              }
            >
              {/* {row.voucherNumber || "--"}{" "} */}
              {row.documentNumber || "--"}{" "}
            </button>
          );
        } else if (row?.transactionType === "INV") {
          return (
            <button
              className="btnInfo"
              onClick={() =>
                detailedPageInvoice(row.documentNumber, row.transactionType)
              }
            >
              {/* {row.voucherNumber || "--"}{" "} */}
              {row.documentNumber || "--"}{" "}
            </button>
          );
        }
      },
      sortable: true,
      width: "200px",
    },
    {
      name: "Particulars",
      id: "companyCodeDesc",
      selector: (row) => row.transactionType || "--",
      cell: (row) => {
        let label = "--";

        if (row.transactionType === "EK") {
          label = "Cash";
        } else if (row.transactionType === "PO") {
          label = "Purchase";
        } else if (row.transactionType === "INV") {
          label = "Invoice";
        } else if (row.transactionType === "BK") {
          label =
            row.bankName || row?.customerBankName || row?.companyBank || "";
        }

        return <span>{label}</span>;
      },
      sortable: true,
      width: "160px",
    },

    // {
    //   name: "Voucher Nr",
    //   selector: (row) => row?.voucherNumber,
    //   cell: (row) => {
    //     if (row.isSpecialRow) return "--";
    //     return (
    //       <button
    //         className="btnInfo"
    //         onClick={() =>
    //           detailedPageInvoice(row.documentNumber, row.transactionType)
    //         }
    //       >
    //         {row.voucherNumber || "--"}{" "}
    //       </button>
    //     );
    //   },
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => <span>{row.remarks || "--"}</span>,
      sortable: true,
      width: "140px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.openingbalance ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalDebitAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.closingBlance ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";

        return (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-danger fw-bold">
              {/* {row?.items?.debitAmount ?? ( row?.items[0]? row?.items[0]?.debitAmount : row?.items?.debitAmount) ?? "--"} */}
              {/* {row?.items?.debitAmount ?? row?.items[0]?.debitAmount ?? "--"} */}
              {/* {row?.items[0]?.debitAmount ?? "--"} */}
              {/* {row?.items?.debitAmount ?? row?.items?.[0]?.debitAmount ?? "--"} */}
              {row?.items
                ? Number(
                    (Array.isArray(row.items)
                      ? row.items.reduce((sum, item) => {
                          return (
                            sum +
                            Number(item?.grossValue ?? item?.debitAmount ?? 0)
                          );
                        }, 0)
                      : Number(
                          row.items?.grossValue ?? row.items?.debitAmount ?? 0,
                        )
                    ).toFixed(0),
                  )
                : "--"}
            </span>
          </div>
        );
      },
      width: "220px",
    },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <span className="fw-bold text-danger">Debit</span>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-danger fw-bold">
    //         {/* {row?.items?.debitAmount || "--"} */}
    //        {(row?.type === "CREDIT" && (row?.items?.debitAmount ||row?.items?.creditAmount) )|| "--"}

    //       </span>
    //     </div>
    //   ),
    //   width: "220px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalCreditAmount ?? 0}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";
        return (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {/* {row?.items?.grossValue ??
              (row?.items[0] ? row?.items[0]?.creditAmount :  row?.items?.creditAmount) ??
              row?.items?.creditAmount ??
              "--"} */}
              {/* {row?.items?.grossValue ?? row?.items[0]?.creditAmount ?? "--"} */}
              {/* {row?.items?.grossValue ?? row?.items?.[0]?.creditAmount ?? "--"}*/}
              {row?.items
                ? Number(
                    (Array.isArray(row.items)
                      ? row.items.reduce((sum, item) => {
                          return (
                            sum +
                            Number(item?.grossValue ?? item?.creditAmount ?? 0)
                          );
                        }, 0)
                      : Number(
                          row.items?.grossValue ?? row.items?.creditAmount ?? 0,
                        )
                    ).toFixed(0),
                  )
                : "--"}
            </span>
          </div>
        );
      },
      width: "220px",
    },
    //     {
    //   name: (
    //     <div className="text-center w-100">
    //       <span className="fw-bold text-primary">Credit </span>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //        {(row?.type === "DEBIT" && (row?.items?.debitAmount ||row?.items?.creditAmount) )|| "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "220px",
    // },

    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //expenseLedgerCol
  const expenseLedgerCol = [
    {
      name: "Date",
      id: "generatedDate",
      selector: (row) => (
        <>
          <span className="text-primary">{formatDate(row.createdAt)}</span>
        </>
      ),
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <>
            <span className="text-primary">{formatDate(row.createdAt)}</span>
          </>
        );
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction",
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <>
            {row?.transactionType === "BK" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  {row?.transaction}
                </span>
              </div>
            ) : row?.transactionType === "PO" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-new-status px-4 mr-2">
                  Purchase
                </span>
              </div>
            ) : row?.transactionType === "INV" ? (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  Sales
                </span>
              </div>
            ) : (
              <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}
                </span>
              </div>
            )}
          </>
        );
      },
      width: "160px",
    },
    {
      name: "Expense Type",
      cell: (row) => {
        if (row.isSpecialRow) return "";

        return (
          <>
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {row?.expenseName}{" "}
              </span>
            </div>
          </>
        );
      },
      width: "200px",
    },

    {
      name: "Particulars",
      id: "companyCodeDesc",
      selector: (row) => row.transactionType || "--",
      cell: (row) => {
        if (row.isSpecialRow) return "";

        let label = "--";

        if (row.transactionType === "EK") {
          label = "Cash";
        } else if (row.transactionType === "PO") {
          label = "Purchase";
        } else if (row.transactionType === "INV") {
          label = "Invoice";
        } else if (row.transactionType === "BK") {
          label =
            row.bankName ||
            row?.customerBankName ||
            row?.customerCodeDesc ||
            "--";
        }

        return <span>{label}</span>;
      },
      sortable: true,
      width: "160px",
    },

    // {
    //   name: "Particulars",
    //   id: "companyCodeDesc",
    //   selector: (row) => row.transactionType || "--",
    //   cell: (row) => {
    //     let label = "--";

    //     if (row.transactionType === "EK") {
    //       label = "Cash";
    //     } else if (row.transactionType === "PO") {
    //       label = "Purchase";
    //     } else if (row.transactionType === "INV") {
    //       label = "Invoice";
    //     } else if (row.transactionType === "BK") {
    //       label =
    //         row.bankName || row?.customerBankName || row?.customerCodeDesc;
    //     }

    //     return <span>{label}</span>;
    //   },
    //   sortable: true,
    //   width: "160px",
    // },
    // {
    //   name: "Transaction",
    //   cell: (row) => {
    //     let statusClass = "bg-table-status bg-table-success-status";
    //     let label = row?.transaction;

    //     if (row?.transactionType === "BK") {
    //       statusClass = "bg-table-status bg-table-new-status";
    //       // label = "Bank Transaction";
    //     } else if (row?.transactionType === "EK") {
    //       statusClass = "bg-table-status bg-table-progress-status";
    //       // label = "Cash Transaction";
    //     } else if (row?.transactionType === "PO") {
    //       statusClass = "bg-table-status bg-table-new-status";
    //       label = "Purchase";
    //     } else if (row?.transactionType === "INV") {
    //       statusClass = "bg-table-status bg-table-success-status";
    //       label = "Invoice";
    //     }

    //     return (
    //       <div className="card-body">
    //         <span className={`${statusClass} px-4 mr-2`}>{label}</span>
    //       </div>
    //     );
    //   },
    //   width: "160px",
    // },
    {
      name: "Transaction ID",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return <strong>Opening Balance</strong>;
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return <strong>Closing Balance</strong>;
        }

        if (row.isSpecialRow) return "";

        return (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transactionType)
            }
          >
            {row.voucherNumber}
          </button>
        );
      },
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Voucher Nr",
    //   selector: (row) => row?.voucherNumber,
    //   cell: (row) => (
    //     // <span className="bg-table-status bg-table-new-status">
    //     //   {row.voucherNumber || "--"}
    //     // </span>
    //     <button
    //       className="btn btnInfo"
    //       onClick={() =>
    //         detailedPageInvoice(row.documentNumber, row.transactionType)
    //       }
    //     >
    //       {row.voucherNumber}{" "}
    //     </button>
    //   ),

    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => {
        if (row.isSpecialRow) return "";

        return <span>{row.remarks || "--"}</span>;
      },
      sortable: true,
      width: "140px",
    },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-danger">Debit</span>
        </div>
      ),
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.openingbalance ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalDebitAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.closingBlance ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";
        if (row.isSpecialRow) return "";
        return (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-danger fw-bold">
              {row?.items?.debitAmount || row?.items[0]?.debitAmount || "--"}
            </span>
          </div>
        );
      },
      width: "220px",
    },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <span className="fw-bold text-danger">Debit</span>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-danger fw-bold">
    //         {/* {row?.items?.debitAmount || "--"} */}
    //        {(row?.type === "CREDIT" && (row?.items?.debitAmount ||row?.items?.creditAmount) )|| "--"}

    //       </span>
    //     </div>
    //   ),
    //   width: "220px",
    // },
    {
      name: (
        <div className="text-center w-100">
          <span className="fw-bold text-primary">Credit</span>
        </div>
      ),
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalCreditAmount ?? 0}</span>
            </div>
          );
        }
        if (row.isSpecialRow) return "";
        return (
          <div
            className="d-flex justify-content-end align-items-center w-100"
            style={{ textAlign: "right" }}
          >
            <span className="text-primary fw-bold">
              {row?.items?.grossValue ||
                row?.items[0]?.creditAmount ||
                row?.items?.creditAmount ||
                "--"}
              {/* {row?.items?.grossValue || row?.items?.creditAmount || "--"} */}
            </span>
          </div>
        );
      },
      width: "220px",
    },
    //     {
    //   name: (
    //     <div className="text-center w-100">
    //       <span className="fw-bold text-primary">Credit </span>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div
    //       className="d-flex justify-content-end align-items-center w-100"
    //       style={{ textAlign: "right" }}
    //     >
    //       <span className="text-primary fw-bold">
    //        {(row?.type === "DEBIT" && (row?.items?.debitAmount ||row?.items?.creditAmount) )|| "--"}
    //       </span>
    //     </div>
    //   ),
    //   width: "220px",
    // },

    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];
  //Cash/bank
  const cashBankCol = [
    {
      name: "Particulars",
      selector: (row) => row.materialLongText,
      cell: (row) => {
        if (row.isSpecialRow) return "";

        return (
          <>
            <div className="table-data">
              <div className="company-body">
                <div
                  onClick={() => handleCashBank(row)}
                  className="company-item"
                >
                  <span className="fw-bold cursor-pointer">{row.bankName}</span>
                </div>{" "}
              </div>
            </div>
          </>
        );
      },
      sortable: true,
    },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <div className="fw-bold text-danger">Closing</div>
    //       <div className="d-flex justify-content-around">
    //         <span className="fw-medium text-danger">Quantity</span>
    //         <span className="fw-medium text-danger">Value</span>
    //       </div>
    //     </div>
    //   ),
    //   cell: (row) => {
    //     return (
    //       <div className="d-flex justify-content-around w-100">
    //         <span className="text-danger fw-bold pe-2">
    //           {row.closingBalance} {row?.uOM || "BAGS"}
    //         </span>
    //         <span className="text-danger fw-bold pe-2">
    //           {parseFloat(row?.totalBasicClosingBalance).toFixed(2) || "--"}
    //         </span>
    //       </div>
    //     );
    //   },
    //   sortable: false,
    // },
  ];

  const cashBankData = [
    { bankName: "CASH", transactionType: "EK" },
    { bankName: "HDFC BANK", transactionType: "BK" },
    { bankName: "UNION BANK OF INDIA", transactionType: "BK" },
    { bankName: "ICICI BANK OF INDIA", transactionType: "BK" },
  ];

  //expense
  const expenseCol = [
    {
      name: (
        <div className="text-start">
          <span className="fw-bold text-success">PARTICULARS</span>
        </div>
      ),
      selector: (row) => row.expenseName,
      cell: (row) => (
        <>
          <div className="table-data">
            <div className="company-body">
              <div onClick={() => handleExpense(row)} className="company-item">
                <span className="fw-bold cursor-pointer">
                  {row.expenseName}
                </span>
              </div>{" "}
            </div>
          </div>
        </>
      ),
      sortable: true,
    },
  ];
  //expense
  const expenseData = [
    {
      expenseName: "Salary",
      expenseType: "Salary",
      expenseTypeCode: "SL",
    },
    {
      expenseName: "EV Charges",
      expenseType: "EV Charges",
      expenseTypeCode: "EC",
    },
    {
      expenseName: "Vehicle Repair and Maintanance",
      expenseType: "Vehicle Repair and Maintanance",
      expenseTypeCode: "VRM",
    },
    {
      expenseName: "Diesel",
      expenseType: "Diesel",
      expenseTypeCode: "DE",
    },
    {
      expenseName: "Telephone and Mobile",
      expenseType: "Telephone and Mobile",
      expenseTypeCode: "TMB",
    },
    {
      expenseName: "Miscellaneous",
      expenseType: "Miscellaneous",
      expenseTypeCode: "ME",
    },
    {
      expenseName: "Electrical",
      expenseType: "Electrical",
      expenseTypeCode: "EL",
    },
    {
      expenseName: "Raw Material",
      expenseType: "Raw Material",
      expenseTypeCode: "RM",
    },
    { expenseName: "Tails", expenseType: "Tails", expenseTypeCode: "TA" },
    { expenseName: "Doors", expenseType: "Doors", expenseTypeCode: "DO" },
    { expenseName: "Steel", expenseType: "Steel", expenseTypeCode: "ST" },
    { expenseName: "Cement", expenseType: "Cement", expenseTypeCode: "CE" },
    { expenseName: "Advance", expenseType: "Advance", expenseTypeCode: "AD" },
    { expenseName: "Others", expenseType: "Others", expenseTypeCode: "OT" },
  ];

  //stock month wise
  const cashBankMonthColumns = [
    // {
    //   name: "Month",
    //   selector: (row) => row.month,
    //   cell: (row) => (
    //     <>
    //       <div className="table-data">
    //         <div className="company-body">
    //           <div
    //             onClick={() => handleMonthClick(row)}
    //             className="company-item"
    //           >
    //             <span className="fw-bold">{row.month}</span>
    //           </div>{" "}
    //         </div>
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "300px",
    // },
    {
      name: "Month",
      selector: (row) => row.month,
      cell: (row) => {
        const monthIndex = parseInt(row.month) - 1;
        const displayMonth = monthNames[monthIndex] || row.month;

        return (
          <div className="table-data">
            <div className="company-body">
              <div
                onClick={() => handleMonthCashBankClick(row)}
                className="company-item"
              >
                <span className="fw-bold">{displayMonth}</span>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "300px",
    },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <div className="fw-bold text-primary">Inwards</div>
    //       <div className="d-flex justify-content-around">
    //         <span className="fw-medium text-primary">Quantity</span>
    //         <span className="fw-medium text-primary">Value</span>
    //       </div>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div className="d-flex justify-content-around w-100">
    //       <div>
    //         {row.totalPoInwardQty ? (
    //           <>
    //             <span className="text-primary fw-bold pe-2">
    //               {row.totalPoInwardQty}
    //             </span>
    //             <span className="text-primary fw-bold">
    //               {row?.uOM || "BAGS"}
    //             </span>
    //           </>
    //         ) : (
    //           <span className="text-primary fw-bold">--</span>
    //         )}
    //       </div>
    //       <span className="text-primary fw-bold">
    //         {row.totalPoInwardNetValue || "--"}
    //       </span>
    //     </div>
    //   ),
    //   sortable: false,
    //   width: "300px",
    // },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <div className="fw-bold text-success">Outwards</div>
    //       <div className="d-flex justify-content-around">
    //         <span className="fw-medium text-success">Quantity</span>
    //         <span className="fw-medium text-success">Value</span>
    //       </div>
    //     </div>
    //   ),
    //   cell: (row) => (
    //     <div className="d-flex justify-content-around w-100">
    //       <div>
    //         {row.totalPoOutwardQty ? (
    //           <>
    //             <span className="text-success fw-bold pe-2">
    //               {row.totalPoOutwardQty}
    //             </span>
    //             <span className="text-success fw-bold fw-bold">
    //               {row.uOM || "BAGS"}
    //             </span>
    //           </>
    //         ) : (
    //           <span className="text-success fw-bold fw-bold">--</span>
    //         )}
    //       </div>
    //       <span className="text-success fw-bold">
    //         {/* {row.totalPoOutwardNetValue || "--"} */}
    //         {parseFloat(row.totalPoInvBasicAmount).toFixed(2) || "--"}
    //       </span>
    //     </div>
    //   ),
    //   sortable: false,
    //   width: "300px",
    // },
    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <div className="fw-bold text-danger">Closing</div>
    //       <div className="d-flex justify-content-around">
    //         <span className="fw-medium text-danger">Quantity</span>
    //         <span className="fw-medium text-danger">Value</span>
    //       </div>
    //     </div>
    //   ),
    //   cell: (row) => {
    //     return (
    //       <div className="d-flex justify-content-around w-100">
    //         <span className="text-danger fw-bold pe-2">
    //           {row.totalClosingBalance} {row?.uOM || "BAGS"}
    //         </span>
    //         <span className="text-danger fw-bold pe-2">
    //           {/* ₹
    //           {parseFloat(row?.totalPoInwardNetValue) -
    //             parseFloat(row?.totalPoOutwardNetValue).toFixed(2)} */}
    //           ₹
    //           {Number(
    //             parseFloat(row?.totalPoInwardNetValue || 0) -
    //               parseFloat(row?.totalPoInvBasicAmount || 0)
    //           ).toFixed(2)}
    //         </span>
    //       </div>
    //     );
    //   },
    //   sortable: false,
    //   width: "300px",
    // },
  ];

  const cashBankMonthData = [
    { month: 1, year: currentYearForData },
    { month: 2, year: currentYearForData },
    { month: 3, year: currentYearForData },
    { month: 4, year: currentYearForData },
    { month: 5, year: currentYearForData },
    { month: 6, year: currentYearForData },
    { month: 7, year: currentYearForData },
    { month: 8, year: currentYearForData },
    { month: 9, year: currentYearForData },
    { month: 10, year: currentYearForData },
    { month: 11, year: currentYearForData },
    { month: 12, year: currentYearForData },
  ];
  //CASH BANK DETAIL PAGE
  // const companyCodeMap = {
  //   SSA: "SRI SRINIVASA ASSOCIATES",
  //   SVT: "SRI VENKATESHWARA TRADERS",
  //   AKE: "AKSHARA ENTERPRIES",
  //   DBC: "DHARANI BUILD CAPITALS",
  //   SSI: "SRI SAPTHAGIRI INFRA",
  //   BRI: "BRINDAVAN INFRA",
  //   SVA: "SRI VENKATESWARA AGENCIES",
  // };
  const cashAllDetails = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      width: "160px",
    },

    {
      name: "ExpensesHead",
      selector: (row) => row.expensesHead,
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return <span className="">{row.expensesHead || "--"}</span>;
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <span className="bg-table-status bg-table-progress-status">
            {row.transaction}
          </span>
        );
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction ID",
      selector: (row) => row?.documentNumber,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return <strong>Opening Balance</strong>;
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return <strong>Closing Balance</strong>;
        }
        if (row.isSpecialRow && row.rowType === "opening") {
          return <strong>Opening Balance</strong>;
        }
        if (row.isSpecialRow) return "";

        return (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transactionType)
            }
          >
            {row.documentNumber}{" "}
          </button>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Particulars",
      selector: (row) => row.customerCodeDesc,
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="">{row.customerCode}</span>
          <span className="">{row.customerCodeDesc}</span>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return <span className="">{row.remarks}</span>;
      },
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Voucher Nr",
    //   selector: (row) => row?.voucherNumber,
    //   cell: (row) => {
    //     if (row.isSpecialRow) return "";

    //     return (
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.voucherNumber || "--"}
    //       </span>
    //     );
    //   },
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Debit",
      selector: (row) => row.items?.[0]?.debitAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalDebitAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.closingBlance ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";
        return (
          <span
            className="bg-table-status bg-table-danger-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.debitAmount
              ? row.items.debitAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      // cell: (row) => (
      //   <span
      //     className="bg-table-status bg-table-danger-status"
      //     style={{ padding: "4px 10px", borderRadius: "10px" }}
      //   >
      //     ₹{" "}
      //     {row.items?.debitAmount
      //       ? row.items.debitAmount.toLocaleString("en-IN")
      //       : "0"}
      //   </span>
      // ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Credit",
      selector: (row) => row.items?.creditAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">0</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalCreditAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow) return "";

        return (
          <span
            className="bg-table-status bg-table-success-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.creditAmount
              ? row.items?.creditAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      // cell: (row) => (
      //   <span
      //     className="bg-table-status bg-table-success-status"
      //     style={{ padding: "4px 10px", borderRadius: "10px" }}
      //   >
      //     ₹{" "}
      //     {row.items?.creditAmount
      //       ? row.items?.creditAmount.toLocaleString("en-IN")
      //       : "0"}
      //   </span>
      // ),
      sortable: true,
      width: "150px",
    },
  ];
  const cashBankAlldetails = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Company",
    //   id: "companyCode",
    //   selector: (row) => companyCodeMap[row.companyCode] || row.companyCode,
    //   cell: (row) => (
    //     <p className="fw-bold">
    //       {companyCodeMap[row.companyCode] ||
    //         row.companyCode ||
    //         row?.companyCodeDesc}
    //     </p>
    //   ),
    //   sortable: true,
    //   width: "240px",
    // },

    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => (
        <>
          {row?.transaction === "Payment" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.transaction}
            </span>
          ) : row?.transaction === "Receipt" ? (
            <span className="bg-table-status bg-table-new-status">
              {row.transaction}
            </span>
          ) : null}
        </>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction ID",
      selector: (row) => row?.documentNumber,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "closing") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">
                {/* {row?.totalCreditAmount ?? "--"} */}
                Closing Balance
              </span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "opening") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">Opening Balance</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";

        return (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transactionType)
            }
          >
            {row.voucherNumber}{" "}
          </button>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Particulars",
      id: "companyBank",
      selector: (row) => row.customerCodeDesc,
      cell: (row) => <p className="fw-bold">{row.customerCodeDesc || ""}</p>,
      sortable: true,
      width: "240px",
    },
    // {
    //   name: "Voucher Nr",
    //   selector: (row) => row?.voucherNumber,
    //   cell: (row) => (
    //     // <span className="bg-table-status bg-table-new-status">
    //     //   {row.voucherNumber || "--"}
    //     // </span>
    //     <button
    //       className="btnInfo"
    //       onClick={() =>
    //         detailedPageInvoice(row.documentNumber, row.transactionType)
    //       }
    //     >
    //       {row.voucherNumber || "--"}{" "}
    //     </button>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      cell: (row) => <span className="">{row.remarks}</span>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Debit",
      selector: (row) => row.items?.[0]?.debitAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalDebitAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "closing") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.closingBlance ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";
        return (
          <span
            className="bg-table-status bg-table-danger-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.debitAmount
              ? row.items.debitAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Credit",
      selector: (row) => row.items?.creditAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "opening") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">0</span>
            </div>
          );
        }
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalCreditAmount ?? "--"}</span>
            </div>
          );
        }
        if (row.isSpecialRow) return "";

        return (
          <span
            className="bg-table-status bg-table-success-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.creditAmount
              ? row.items?.creditAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Transaction",
    //   selector: (row) => row.transactionMode,
    //   cell: (row) => <span>{row.transactionMode}</span>,
    //   sortable: true,
    //   width: "140px",
    // },

    // {
    //   name: "Bank Trn.Date",
    //   selector: (row) => row.bankTransactionDate,
    //   cell: (row) => <span>{row.bankTransactionDate}</span>,
    //   sortable: true,
    //   width: "140px",
    // },

    /* --------- */
    //   {
    //   name: "Date",
    //   selector: (row) => row.date,
    //   cell: (row) => (
    //     <span>
    //    { row.date}
    //     </span>
    //   ),
    //   sortable: true,
    //   width: "100px",
    // },

    // {
    //   name: "Company",
    //   selector: (row) => row.companyCodeDesc,
    //   cell: (row) => (
    //     <>
    //       <span className="fw-bold">{row.companyCodeDesc}</span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "240px",
    // },
    // {
    //   name: "Customer",
    //   cell: (row) => (
    //     <div className="d-flex flex-column">
    //       <p className="m-0 fw-bold"> {row.documentNumber} </p>
    //       <p className="m-0"> {row.customerCode} </p>
    //     </div>
    //   ),
    //   width: "160px",
    // },

    // {
    //   name: "Debit",
    //   selector: (row) => row.items?.debitAmount,
    //   cell: (row) => (
    //     <span
    //       className="bg-table-status bg-table-danger-status"
    //       style={{ padding: "4px 10px", borderRadius: "10px" }}
    //     >
    //       ₹{" "}
    //       {row.items?.debitAmount
    //         ? row.items.debitAmount.toLocaleString("en-IN")
    //         : "0"}
    //     </span>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Credit",
    //   selector: (row) => row.items?.creditAmount,
    //   cell: (row) => (
    //     <span
    //       className="bg-table-status bg-table-success-status"
    //       style={{ padding: "4px 10px", borderRadius: "10px" }}
    //     >
    //       ₹{" "}
    //       {row.items?.creditAmount
    //         ? row.items?.creditAmount.toLocaleString("en-IN")
    //         : "0"}
    //     </span>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
  ];

  //sales/invoice ledger
  const salesLedgerCol = [
    {
      name: "Date",
      selector: (row) => row.date,
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{formatDate(row?.date) || ""}</span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <span className="bg-table-status bg-table-progress-status">
            {row.transaction}
          </span>
        );
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction ID",

      selector: (row) => row?.documentNumber,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <>
              <div
                className="d-flex justify-content-end align-items-center w-100"
                style={{ textAlign: "right" }}
              >
                <span className="fw-bold">Total</span>
              </div>
            </>
          );
        }
        if (row.isSpecialRow) return "";
        return (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transactionType)
            }
          >
            {row.documentNumber}{" "}
          </button>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Particulars",
      selector: (row) => row.customerName,
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{row?.customerName || ""}</span>
          <span className="">{row?.customerCode}</span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Debit",
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <>
              <div
                className="d-flex justify-content-end align-items-center w-100"
                style={{ textAlign: "right" }}
              >
                <span className="fw-bold">
                  {row?.totalDebitAmount !== null &&
                  row?.totalDebitAmount !== undefined &&
                  !isNaN(row.totalDebitAmount)
                    ? Number(row.totalDebitAmount).toFixed(3)
                    : "--"}
                </span>
              </div>
            </>
          );
        }
        if (row.isSpecialRow) return "";
        return (
          <span
            className="bg-table-status bg-table-danger-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹ {Math.round(row?.items?.debitAmount).toFixed(2) ?? 0}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Credit",
      selector: (row) => row.items?.creditAmount,
      cell: (row) => {
        if (row.isSpecialRow) return "";
        return (
          <span
            className="bg-table-status bg-table-success-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.creditAmount
              ? row.items?.creditAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
  ];
  //purchase ledger
  const purchaseLedgerCol = [
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      width: "160px",
    },

    {
      name: "Transaction",

      selector: (row) => row.transaction,
      cell: (row) => {
        if (row.isSpecialRow) return "";

        return (
          <span className="bg-table-status bg-table-progress-status">
            {row.transaction}
          </span>
        );
      },
      sortable: true,
      width: "140px",
    },

    {
      name: "Transaction ID",
      selector: (row) => row?.documentNumber,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">
                {/* {row?.totalCreditAmount ?? "--"} */}
                Total
              </span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";

        return (
          <button
            className="btnInfo"
            onClick={() =>
              detailedPageInvoice(row.documentNumber, row.transactionType)
            }
          >
            {row.documentNumber}{" "}
          </button>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: "Particulars",
      selector: (row) => row.customerName,
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{row?.customerName || ""}</span>
          <span className="">{row?.customerCode}</span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Debit",
      selector: (row) => row.items?.[0]?.debitAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalDebitAmount ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";

        return (
          <span
            className="bg-table-status bg-table-danger-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.debitAmount
              ? row.items.debitAmount.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Credit",
      selector: (row) => row.items?.creditAmount,
      cell: (row) => {
        if (row.isSpecialRow && row.rowType === "subTotal") {
          return (
            <div
              className="d-flex justify-content-end align-items-center w-100"
              style={{ textAlign: "right" }}
            >
              <span className="fw-bold">{row?.totalGrossValue ?? "--"}</span>
            </div>
          );
        }

        if (row.isSpecialRow) return "";
        return (
          <span
            className="bg-table-status bg-table-success-status"
            style={{ padding: "4px 10px", borderRadius: "10px" }}
          >
            ₹{" "}
            {row.items?.grossValue
              ? row.items?.grossValue.toLocaleString("en-IN")
              : "0"}
          </span>
        );
      },
      sortable: true,
      width: "150px",
    },
  ];

  useEffect(() => {
    if (ledgerFilters[0]?.transactionType === "BK") {
      setcashBankAlldetails(cashBankAlldetails);
    } else if (ledgerFilters[0]?.transactionType === "EK") {
      setcashBankAlldetails(cashAllDetails);
    }
    // eslint-disable-next-line
  }, [ledgerFilters]);

  //naviagate detials pageP
  const detailedPageInvoice = (invoiceNumber, transaction) => {
    // console.log(">>invoiceNumber", invoiceNumber, transaction);
    if (!invoiceNumber || !transaction) {
      console.error("Missing invoice number or transaction.");
      return;
    }
    if (transaction === "PO" || transaction === "Purchase") {
      dispatch(purchaseNr(invoiceNumber));
      navigate(Constants.CUSTOMER_V2_PURCHASE_DETAILS);
    } else if (transaction === "INV" || transaction === "Sales") {
      dispatch(addInvoiceID(invoiceNumber));
      navigate(Constants.CUSTOMER_V2_INVOICE_DETAILS);
    } else if (
      transaction === "BK" ||
      transaction === "Payment" ||
      transaction === "Receipt"
    ) {
      dispatch(bankStatements(invoiceNumber));
      navigate(Constants.CUSTOMER_V2_BANK_STATEMENT_DETAILS);
    } else if (transaction === "EK" || transaction === "Expenses") {
      dispatch(cashExpensesNr(invoiceNumber));
      navigate(Constants.CUSTOMER_V2_CASH_EXPENSES_DETAILS);
    } else {
      console.error("Invalid transaction type.");
    }
  };
  const stockAlldetails = [
    {
      name: "Date",
      // id: "createdAt",
      selector: (row) => (
        <>
          <span className=" text-primary">
            {formatDate(row.generatedDateObj)}
          </span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Company",
      // id: "companyCodeDesc",
      omit: true,
      selector: (row) => row.companyCodeDesc || "--",
      cell: (row) => (
        <>
          <span>{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Customer ",
      // id: "customerName",
      selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          <span>{row?.customerName || "--"}</span>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material",
      // id: "materialDescription",
      selector: (row) => row?.materialLongText || "--",
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {row?.materialLongText || "--"}
          </span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Transaction",
      // selector: (row) => row.customerName || "--",
      cell: (row) => (
        <>
          {row?.transactionType === "PO" ? (
            <div className="card-body">
              <span className="bg-table-status bg-table-new-status px-4 mr-2">
                {/*  {row?.transaction } */} Purchase
              </span>
            </div>
          ) : (
            <div className="card-body">
              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                Sales {/* {row?.transaction } */}{" "}
              </span>
            </div>
          )}
          {/* <div className="card-body">
                <span className="bg-table-status bg-table-success-status px-4 mr-2">
                  {row?.transaction}{" "}
                </span>
              </div> */}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Transaction ID",
      // id: "documentNumber",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPageInvoice(row?.documentNumber, row?.transactionType)
          }
        >
          {row?.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-primary">Inwards</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-primary">Quantity</span>
            <span className="fw-medium text-primary">Value</span>
          </div>
        </div>
      ),
      cell: (row) => (
        <div className="d-flex justify-content-around w-100">
          <div>
            {row.poInwardQty ? (
              <>
                <span className="text-primary fw-bold pe-2">
                  {row?.poInwardQty || "--"}
                </span>
                <span className="text-primary fw-bold">
                  {row.uOM || "BAGS"}
                </span>
              </>
            ) : (
              <span className="text-primary fw-bold">--</span>
            )}
          </div>
          <span className="text-primary fw-bold">
            {row.poInwardNetValue || "--"}
          </span>
        </div>
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-success">Outwards</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-success">Quantity</span>
            <span className="fw-medium text-success">Value</span>
          </div>
        </div>
      ),
      cell: (row) => (
        <div className="d-flex justify-content-around w-100">
          <div>
            {row.poOutwardQty ? (
              <>
                <span className="text-success fw-bold pe-2">
                  {row.poOutwardQty}
                </span>
                <span className="text-success fw-bold fw-bold">
                  {row.uOM || "BAGS"}
                </span>
              </>
            ) : (
              <span className="text-success fw-bold fw-bold">--</span>
            )}
          </div>
          <span className="text-success fw-bold">
            {row.poInvBasicAmount || "--"}
          </span>
        </div>
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: (
        <div className="text-center w-100">
          <div className="fw-bold text-danger">Closing</div>
          <div className="d-flex justify-content-around">
            <span className="fw-medium text-danger">Quantity</span>
            <span className="fw-medium text-danger">Value</span>
          </div>
        </div>
      ),
      cell: (row, rowIndex) => {
        let closingQuantity = 0;
        let closingValue = 0;

        // Calculate cumulative closing balance up to current row
        tableData?.slice(0, rowIndex + 1)?.forEach((item) => {
          if (item.transactionType === "PO") {
            closingQuantity += Number(item.poInwardQty || 0);
            closingValue += Number(item.poInwardNetValue || 0);
          } else if (item.transactionType === "INV") {
            closingQuantity -= Number(item.poOutwardQty || 0);
            closingValue -= Number(item.poInvBasicAmount || 0);
          }
        });

        return (
          <div className="d-flex justify-content-around w-100">
            <span className="text-danger fw-bold pe-2">
              {closingQuantity} {row.uOM || "BAGS"}
            </span>
            <span className="text-danger fw-bold pe-2">
              ₹{closingValue.toFixed(2) || ""}
            </span>
          </div>
        );
      },
      sortable: false,
      width: "200px",
    },

    // {
    //   name: (
    //     <div className="text-center w-100">
    //       <div className="fw-bold text-danger">Closing</div>
    //       <div className="d-flex justify-content-around">
    //         <span className="fw-medium text-danger">Quantity</span>
    //         <span className="fw-medium text-danger">Value</span>
    //       </div>
    //     </div>
    //   ),
    //   cell: (row, rowIndex) => {
    //     let closingQuantity = 0;
    //     let closingValue = 0;

    //     // Loop from 0 to current row index
    //     tableData?.slice(0, rowIndex + 1)?.forEach((item) => {
    //       if (item.transaction === "Purchase") {
    //         closingQuantity += Number(item.poOrderQuantity || 0);
    //         closingValue += Number(item.poBasicAmount || 0);
    //       } else if (item.transaction === "Sales") {
    //         closingQuantity -= Number(item.orderQuantityLoad || 0);
    //         closingValue -= Number(item.basicAmount || 0);
    //       }
    //     });

    //     return (
    //       <div className="d-flex justify-content-around w-100">
    //         <span className="text-danger fw-bold pe-2">
    //           {closingQuantity} {row.uOM || "BAGS"}
    //         </span>
    //         <span className="text-danger fw-bold pe-2">
    //           ₹{closingValue.toFixed(2)}
    //         </span>
    //       </div>
    //     );
    //   },
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Month",
      id: "month",
      omit: true,
    },
  ];

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const nextStep = () => {
    dispatch(updateStep(ledgersSteps + 1));
  };

  const prevStep = () => {
    if (ledgersSteps === 2) {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedInputs = {
        ...formInputs,
        companyCode: "",
        description: "",
        reports: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        companyCode: "",
        description: "",
        reports: "",
        companyAddress: "",
      };

      dispatch(updateLedgerFilter(updatedLedgerFilter));
      setFormInputs(updatedInputs);
    }
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "EXPENSE") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
      };
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 4 && ledgerFilters[0]?.reportType === "EXPENSE") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        expenseTypeCode: "",
        expenseName: "",
        year: "",
        month: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "CASH_BANK") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));
      // const updatedInputs = {
      //   ...formInputs,
      //   reports: "",
      //   reportType: "",
      // };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
      };
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    //SALES
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
        month: "",
        year: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    //PURCHASE
    if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "PURCHASE") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
        month: "",
        year: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    //cash bank
    if (ledgersSteps === 4 && ledgerFilters[0]?.reportType === "CASH_BANK") {
      dispatch(updateStep(ledgersSteps - 1));
      // dispatch(getLedgerList({}));
      // const updatedInputs = {
      //   ...formInputs,
      //   product: "",
      //   materialCode: "",
      // };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        bankName: "",
        materialCode: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 3 && ledgerFilters[0]?.reports === "Stock Summary") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));
      const updatedInputs = {
        ...formInputs,
        reports: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
      };
      setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 3 && ledgerFilters[0]?.reports === "Ledger") {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedInputs = {
        ...formInputs,
        reports: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        reports: "",
        reportType: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);

      setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Stock Summary") {
      dispatch(updateStep(ledgersSteps - 1));
      dispatch(getLedgerList({}));
      const updatedInputs = {
        ...formInputs,
        product: "",
        materialCode: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        product: "",
        materialCode: "",
      };
      setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedInputs = {
        ...formInputs,
        month: "",
        years: "",
        year: "",
        ledgers: "",
        ledgersQuerName: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        month: "",
        years: "",
        year: "",
        ledgers: "",
        ledgersQuerName: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
    }
    if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedInputs = {
        ...formInputs,
        month: "",
        years: "",
        year: "",
        ledgers: "",
        ledgersQuerName: "",
        customerAddress: "",
      };
      const updatedLedgerFilter = {
        ...ledgerFilters,
        month: "",
        years: "",
        year: "",
        ledgers: "",
        ledgersQuerName: "",
        customerAddress: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
      setOpeningValue(0);
    }
    if (ledgersSteps === 5 && ledgerFilters[0]?.reports === "Stock Summary") {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        month: "",
        years: "",
      };
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
      // setReports(""); // or null
    }
    if (ledgersSteps === 5 && ledgerFilters[0]?.reportType === "CASH_BANK") {
      dispatch(updateStep(ledgersSteps - 1));

      const updatedLedgerFilter = {
        ...ledgerFilters,
        month: "",
        years: "",
      };
      const cleareDate = {
        ...getDate,
        fromDate: "",
        toDate: "",
      };
      setDate(cleareDate);
      // setFormInputs(updatedInputs);
      dispatch(updateLedgerFilter(updatedLedgerFilter));
      // setReports(""); // or null
    }
  };

  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  useEffect(() => {
    loadMasterData();
    // eslint-disable-next-line
  }, []);

  const handleCardClick = (report) => {
    const updatedInputs = {
      ...formInputs,
      reports: report.name,
      reportType: report.code,
      month: report.month || "",
      year: report.year || "",
    };
    const updatedLedgerFilter = {
      ...ledgerFilters,
      reports: report.name,
      reportType: report.code,
      month: report.month || "",
      year: report.year || "",
    };
    setFormInputs(updatedInputs);
    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ dispatch to Redux
    nextStep();
  };

  const handleClickLedgers = (ledgers) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const updatedLedgerFilter = {
      ...ledgerFilters,
      ledgers: ledgers.name,
      ledgersQuerName: ledgers.code,
      year: currentYear,
      month: currentMonth,
    };

    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ Sync with Redux

    // Set appropriate ledger column based on the code
    switch (ledgers.code) {
      case "ROUNDOFF_LEDGER":
        SetledgersColumn(roundOff);
        break;
      case "SALES_CGST_14_LEDGER":
        SetledgersColumn(salesCgst14Ledgers);
        break;
      case "SALES_SGST_14_LEDGER":
        SetledgersColumn(salesSgst14Ledgers);
        break;
      case "SALES_CGST_9_LEDGER":
        SetledgersColumn(salesCgst9Ledgers);
        break;
      case "SALES_SGST_9_LEDGER":
        SetledgersColumn(salesSgst9Ledgers);
        break;
      case "PURCHASE_CGST_14_LEDGER":
        SetledgersColumn(purchaseCgst14ledgers);
        break;
      case "PURCHASE_SGST_14_LEDGER":
        SetledgersColumn(purchaseSgst14ledgers);
        break;
      case "PURCHASE_CGST_9_LEDGER":
        SetledgersColumn(purchaseCgst9ledgers);
        break;
      case "PURCHASE_SGST_9_LEDGER":
        SetledgersColumn(purchaseSgst9ledgers);
        break;
      case "PURCHASE_IGST_LEDGER":
        SetledgersColumn(igstLedgers);
        break;
      default:
        SetledgersColumn([]);
    }
    nextStep();
  };
  useEffect(() => {
    if (ledgerFilters[0]?.ledgersQuerName) {
      switch (ledgerFilters[0]?.ledgersQuerName) {
        case "ROUNDOFF_LEDGER":
          SetledgersColumn(roundOff);
          break;
        case "SALES_CGST_14_LEDGER":
          SetledgersColumn(salesCgst14Ledgers);
          break;
        case "SALES_SGST_14_LEDGER":
          SetledgersColumn(salesSgst14Ledgers);
          break;
        case "SALES_CGST_9_LEDGER":
          SetledgersColumn(salesCgst9Ledgers);
          break;
        case "SALES_SGST_9_LEDGER":
          SetledgersColumn(salesSgst9Ledgers);
          break;
        case "PURCHASE_CGST_14_LEDGER":
          SetledgersColumn(purchaseCgst14ledgers);
          break;
        case "PURCHASE_SGST_14_LEDGER":
          SetledgersColumn(purchaseSgst14ledgers);
          break;
        case "PURCHASE_CGST_9_LEDGER":
          SetledgersColumn(purchaseCgst9ledgers);
          break;
        case "PURCHASE_SGST_9_LEDGER":
          SetledgersColumn(purchaseSgst9ledgers);
          break;
        case "PURCHASE_IGST_LEDGER":
          SetledgersColumn(igstLedgers);
          break;
        case "Customer":
          SetledgersColumn(customerLedger);
          break;
        default:
          SetledgersColumn([]);
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleProdcutClick = (data) => {
    const updatedLedgerFilter = {
      ...ledgerFilters,
      product: data?.materialLongText,
      materialCode: data?.materialCode,
    };

    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ dispatch to Redux
    nextStep();
  };
  const handleCashBank = (data) => {
    const updatedLedgerFilter = {
      ...ledgerFilters,
      bankName: data?.bankName,
      year: data?.year,
      transactionType: data?.transactionType,
    };

    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ dispatch to Redux
    nextStep();
  };
  const handleExpense = (data) => {
    const updatedLedgerFilter = {
      ...ledgerFilters,
      expenseTypeCode: data?.expenseTypeCode,
      expenseName: data?.expenseName,
      year: currentYear,
      month: currentMonth,
    };

    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ dispatch to Redux
    nextStep();
  };

  const handleCompanyClick = (item) => {
    // console.log(">>item",item)
    getCompanyMaster(item?.code);

    const updatedLedgerFilter = {
      ...ledgerFilters,
      description: item.description,
      companyCode: item.id,
      // companyAddress: getCompanyDetails?.address+ getCompanyDetails?.address2+getCompanyDetails?.address3
      companyAddress: `${getCompanyDetails?.address || ""} ${
        getCompanyDetails?.address2 || ""
      } ${getCompanyDetails?.address3 || ""}`.trim(),
    };
    dispatch(updateLedgerFilter(updatedLedgerFilter));
    nextStep();
  };

  const handleMonthClick = (data) => {
    const updatedLedgerFilter = {
      ...ledgerFilters,
      month: data?.month,
      years: data?.year,
    };
    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ Sync with Redux
    nextStep();
  };
  const handleMonthCashBankClick = (data) => {
    const updatedLedgerFilter = {
      ...ledgerFilters,
      month: data?.month,
      years: data?.year,
    };
    dispatch(updateLedgerFilter(updatedLedgerFilter)); // ✅ Sync with Redux
    nextStep();
  };

  const loadReport = async () => {
    if (reportState?.data) {
      let obj = {
        queryName: formInputs?.ledgers,
        page: 1,
        per_page: 10,
        group: null,
      };

      dispatch(loadCustomerLedgers(obj));
    }
  };

  //get outstanding amount

  useEffect(() => {
    loadReport();
    // eslint-disable-next-line
  }, []);

  //search function
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {};
    const updatedLedgerFilter = {
      ...ledgerFilters[0],
      year: filters?.year,
      month: filters?.month,
    };

    dispatch(updateLedgerFilter(updatedLedgerFilter));

    if (ledgerFilters[0]?.reports === "Stock Summary") {
      // If description is "Customer"
      obj = {
        queryName: "SpecificMaterialByCompanyDaywise",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode,
        materialCode: ledgerFilters[0]?.materialCode,
        year: filters?.year,
        month: filters?.month,
        page: 1,
        per_page: 10,
        timeZone: "Asia/Calcutta",
      };
    } else if (ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        year: filters?.year,
        month: filters?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };
    } else if (ledgerFilters[0]?.reportType === "EXPENSE") {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
    } else if (ledgerFilters[0]?.reportType === "PURCHASE") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        year: filters?.year,
        month: filters?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };
    } else if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
      // obj = {
      //   queryName: "Customer_Ledger_By_Customer_List",
      //   module: "",
      //   companyCode: ledgerFilters[0]?.companyCode,
      //   customerCode: ledgerFilters[0]?.customerCode,
      //   year: filters?.year,
      //   month: filters?.month,
      //   page: 1,
      //   per_page: 10,
      //   rowFilter: {
      //     $and: [
      //       {
      //         companyCodeDesc: ledgerFilters[0]?.description,
      //       },
      //     ],
      //   },
      //   timeZone: "Asia/Calcutta",
      // };
    } else if (ledgerFilters[0]?.reports === "Ledger") {
      if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
        obj = {
          queryName: "Customer_Ledger_By_Customer_List",
          module: "",
          companyCode: ledgerFilters[0]?.companyCode,
          customerCode: ledgerFilters[0]?.customerCode,
          year: filters?.year,
          month: filters?.month,
          page: 1,
          per_page: 10,
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
              },
            ],
          },
          timeZone: "Asia/Calcutta",
        };
      } else {
        obj = {
          queryName: ledgerFilters[0]?.ledgersQuerName,
          page: 1,
          per_page: 10,
          searchTerm: "",
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
                month: filters?.month,
                year: filters?.year,
              },
            ],
          },
        };
      }
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: filters?.year,
        month: filters?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      const Customer_BankAndExpenses_List = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        // bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: filters?.years,
        month: filters?.month,
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(Customer_BankAndExpenses_List));
    } else {
      console.warn("Unsupported type in ledgerFilters");
      return;
    }

    dispatch(getLedgerList(obj));
  };

  //customer ledgers
  const handleClickCustomerLedger = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const updatedLedgerFilter = {
      ...ledgerFilters,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.id,
      [getDropdownData?.textDesc]: getDropdownData?.description,
      customerAddress: getDropdownData?.customerAddress,
      ledgersQuerName: "Customer",
      year: currentYear,
      month: currentMonth,
      fromDate: formInputs?.fromDate,
      toDate: formInputs?.toDate,
    };
    dispatch(updateLedgerFilter(updatedLedgerFilter));
    SetledgersColumn(customerLedger);
    nextStep();

    if (
      getDate?.fromDate &&
      ledgerFilters?.[0]?.companyCode &&
      ledgerFilters?.[0]?.customerCode
    ) {
      loadCustomerOutStanding();
    }
  };

  //handle rowchange
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    if (ledgersSteps === 3 && ledgerFilters[0]?.reports === "Stock Summary") {
      obj = {
        queryName: "MaterialListByCompany",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year || "",
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: newPerPage,
      };
    } else if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: page,
        per_page: newPerPage,
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyAndCurYearMonthly",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: newPerPage,
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              // year: ledgerFilters[0]?.year,
              // month: ledgerFilters[0]?.month,
              ...(getDate?.fromDate &&
                ledgerFilters.years && {
                  year: ledgerFilters.years,
                }),

              ...(getDate?.fromDate &&
                ledgerFilters.month && {
                  month: ledgerFilters.month,
                }),

              postingDate: {
                $gte: getDate?.fromDate || "",
                $lte: getDate?.toDate || "",
              },
            },
          ],
        },
        page: page,
        per_page: newPerPage,
      };
      // obj = {
      //   queryName: "Customer_Ledger_By_Customer_List",
      //   module: "",
      //   companyCode: ledgerFilters[0]?.companyCode || "",
      //   materialCode: ledgerFilters[0]?.materialCode || "",
      //   customerCode: ledgerFilters[0]?.customerCode || "",
      //   year: ledgerFilters[0]?.year,
      //   month: ledgerFilters[0]?.month || "",
      //   page: page,
      //   per_page: newPerPage,
      //   rowFilter: {
      //       $and: [
      //         {
      //           companyCodeDesc: ledgerFilters[0]?.description,
      //         },
      //       ],
      //     },
      // };
    } else if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") {
      if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
        obj = {
          queryName: "Customer_Ledger_By_Customer_List",
          module: "",
          companyCode: ledgerFilters[0]?.companyCode || "",
          materialCode: ledgerFilters[0]?.materialCode || "",
          customerCode: ledgerFilters[0]?.customerCode || "",
          // year: ledgerFilters[0]?.year,
          // month: ledgerFilters[0]?.month || "",
          ...(getDate?.fromDate &&
            ledgerFilters.years && {
              year: ledgerFilters.years,
            }),

          ...(getDate?.fromDate &&
            ledgerFilters.month && {
              month: ledgerFilters.month,
            }),

          page: page,
          per_page: newPerPage,
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
              },
            ],
          },
        };
      } else {
        obj = {
          queryName: ledgerFilters[0]?.ledgersQuerName,
          page: page,
          per_page: newPerPage,
          searchTerm: "",
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
                month: ledgerFilters[0]?.month,
                year: ledgerFilters[0]?.year,
              },
            ],
          },
        };
      }
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyDaywise",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: newPerPage,
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      const Customer_BankAndExpenses_List = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(Customer_BankAndExpenses_List));
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        // bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(obj));
    }
    setNewPerPage(newPerPage);
    dispatch(getLedgerList(obj));
  };

  //handle page change
  const handlePageChange = (page) => {
    let obj = {};
    if (ledgersSteps === 3 && ledgerFilters[0]?.reports === "Stock Summary") {
      obj = {
        queryName: "MaterialListByCompany",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year || "",
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: getNewPerPage,
      };
    } else if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              year: ledgerFilters[0]?.year,
              month: ledgerFilters[0]?.month,
            },
          ],
        },
        page: page,
        per_page: getNewPerPage,
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyAndCurYearMonthly",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: getNewPerPage,
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              // year: ledgerFilters[0]?.year,
              // month: ledgerFilters[0]?.month,
              ...(getDate?.fromDate &&
                ledgerFilters.years && {
                  year: ledgerFilters.years,
                }),

              ...(getDate?.fromDate &&
                ledgerFilters.month && {
                  month: ledgerFilters.month,
                }),

              postingDate: {
                $gte: getDate?.fromDate || "",
                $lte: getDate?.toDate || "",
              },
            },
          ],
        },
        page: page,
        per_page: getNewPerPage,
      };
      // obj = {
      //   queryName: "Customer_Ledger_By_Customer_List",
      //   module: "",
      //   companyCode: ledgerFilters[0]?.companyCode || "",
      //   materialCode: ledgerFilters[0]?.materialCode || "",
      //   customerCode: ledgerFilters[0]?.customerCode || "",
      //   year: ledgerFilters[0]?.year,
      //   month: ledgerFilters[0]?.month || "",
      //   page: page,
      //   per_page: getNewPerPage,
      // };
    } else if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") {
      if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
        obj = {
          queryName: "Customer_Ledger_By_Customer_List",
          module: "",
          companyCode: ledgerFilters[0]?.companyCode || "",
          materialCode: ledgerFilters[0]?.materialCode || "",
          customerCode: ledgerFilters[0]?.customerCode || "",
          // year: ledgerFilters[0]?.year,
          // month: ledgerFilters[0]?.month || "",
          ...(getDate?.fromDate &&
            ledgerFilters.years && {
              year: ledgerFilters.years,
            }),

          ...(getDate?.fromDate &&
            ledgerFilters.month && {
              month: ledgerFilters.month,
            }),

          fromDate: getDate?.fromDate || "",
          toDate: getDate?.toDate || "",
          page: page,
          per_page: getNewPerPage,
        };
      } else {
        obj = {
          queryName: ledgerFilters[0]?.ledgersQuerName,
          page: page,
          per_page: getNewPerPage,
          searchTerm: "",
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
                month: ledgerFilters[0]?.month,
                year: ledgerFilters[0]?.year,
              },
            ],
          },
        };
      }
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyDaywise",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: page,
        per_page: getNewPerPage,
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(obj));
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        // bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };

      dispatch(getLedgerList(obj));
    }
    dispatch(getLedgerList(obj));
  };

  //handleDownloadExcel
  const handleDownloadExcel = async () => {
    let obj = {};
    if (ledgersSteps === 3 && ledgerFilters[0]?.reports === "Stock Summary") {
      obj = {
        queryName: "MaterialListByCompany",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year || "",
        month: ledgerFilters[0]?.month || "",
        page: 1,
        per_page: reportDatapagination?.total,
      };
    } else if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [{ transactionType: "INV" }],
        },
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        month: ledgerFilters[0]?.month,
        year: ledgerFilters[0]?.year,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [{ transactionType: "PO" }],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyAndCurYearMonthly",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: 1,
        per_page: reportDatapagination?.total,
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Customer_List",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        postingDate: {
          $gte: getDate?.fromDate || "",
          $lte: getDate?.toDate || "",
        },
        page: 1,
        per_page: reportDatapagination?.total,
      };
    } else if (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") {
      if (ledgerFilters[0]?.ledgersQuerName === "Customer") {
        obj = {
          queryName: "Customer_Ledger_By_Customer_List",
          module: "",
          companyCode: ledgerFilters[0]?.companyCode || "",
          materialCode: ledgerFilters[0]?.materialCode || "",
          customerCode: ledgerFilters[0]?.customerCode || "",
          year: ledgerFilters[0]?.year,
          month: ledgerFilters[0]?.month || "",
          page: 1,
          per_page: reportDatapagination?.total,
        };
      } else {
        obj = {
          queryName: ledgerFilters[0]?.ledgersQuerName,
          page: 1,
          per_page: 10,
          searchTerm: "",
          rowFilter: {
            $and: [
              {
                companyCodeDesc: ledgerFilters[0]?.description,
                month: ledgerFilters[0]?.month,
                year: ledgerFilters[0]?.year,
              },
            ],
          },
        };
      }
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reports === "Stock Summary"
    ) {
      obj = {
        queryName: "SpecificMaterialByCompanyDaywise",
        module: "",
        companyCode: ledgerFilters[0]?.companyCode || "",
        materialCode: ledgerFilters[0]?.materialCode || "",
        customerCode: ledgerFilters[0]?.customerCode || "",
        year: ledgerFilters[0]?.year,
        month: ledgerFilters[0]?.month || "",
        page: 1,
        per_page: reportDatapagination?.total,
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "EK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Expenses_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        // bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        year: ledgerFilters[0]?.years,
        month: ledgerFilters[0]?.month,
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
            },
          ],
        },
      };
    }
    setIsDownloading(true);
    try {
      await ItemService.downloadExcel(obj).then((item) => {
        const url = window.URL.createObjectURL(new Blob([item]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Export_${obj?.queryName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsDownloading(false);
      }, 5000);
    }
  };

  //printout
  const PrintCustomerLedger = lazy(() => import("./customerLedgerPrintout"));

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    documentTitle: `Ledger`,
    // onAfterPrint: () => setShowPrint(false),
    pageStyle: pageStyle,
  });

  //from Date To date
  const formatToInputDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    const filters = ledgerFilters?.[0];

    if (
      (filters?.year || filters?.years) &&
      filters?.month &&
      !getDate.fromDate &&
      !getDate.toDate
    ) {
      const year = Number(filters?.year) || Number(filters?.years);
      const month = Number(filters.month);

      const startDate = new Date(Date.UTC(year, month - 1, 1));
      const endDate = new Date(Date.UTC(year, month, 0));

      setDate({
        fromDate: formatToInputDate(startDate),
        toDate: formatToInputDate(endDate),
      });
    }
    // eslint-disable-next-line
  }, [ledgerFilters]); // ✅ correct dependency

  const onInputChange = ({ target: { name, value } }) => {
    setDate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filteByDate = () => {
    let obj = {};
    console.log(">>obje",obj)
    if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.ledgersQuerName === "Customer"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters[0]?.companyCode,
              customerCode: ledgerFilters[0]?.customerCode,
              // year: getDate?.fromDate ? ledgerFilters[0]?.years : "",
              // month: getDate?.fromDate ? ledgerFilters[0]?.month : "",
              ...(getDate?.fromDate &&
                ledgerFilters.years && {
                  year: ledgerFilters.years,
                }),

              ...(getDate?.fromDate &&
                ledgerFilters.month && {
                  month: ledgerFilters.month,
                }),
              postingDate: {
                $gte: getDate?.fromDate,
                $lte: getDate?.toDate,
              },
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
    } else if (ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        // year: getDate?.fromDate ? ledgerFilters[0]?.years : "",
        // month: getDate?.fromDate ? ledgerFilters[0]?.month : "",
        ...(getDate?.fromDate &&
          ledgerFilters.years && {
            year: ledgerFilters.years,
          }),

        ...(getDate?.fromDate &&
          ledgerFilters.month && {
            month: ledgerFilters.month,
          }),
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              transactionType: "INV",

              postingDate: {
                $gte: getDate?.fromDate,
                $lte: getDate?.toDate,
              },
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 3 &&
      ledgerFilters[0]?.reportType === "PURCHASE"
    ) {
      obj = {
        queryName: "Customer_Ledger_By_Company_List",
        companyCode: ledgerFilters[0]?.companyCode,
        // year: getDate?.fromDate ? ledgerFilters[0]?.years : "",
        // month: getDate?.fromDate ? ledgerFilters[0]?.month : "",
        ...(getDate?.fromDate &&
          ledgerFilters.years && {
            year: ledgerFilters.years,
          }),

        ...(getDate?.fromDate &&
          ledgerFilters.month && {
            month: ledgerFilters.month,
          }),
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              transactionType: "PO",
              postingDate: {
                $gte: getDate?.fromDate,
                $lte: getDate?.toDate,
              },
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 5 &&
      ledgerFilters[0]?.reportType === "CASH_BANK" &&
      ledgerFilters[0]?.transactionType === "BK"
    ) {
      obj = {
        // queryName: "Customer_BankAndExpenses_List",
        queryName: "Customer_Bank_Ledger",
        module: "",
        companyCode: "",
        materialCode: "",
        bankName: ledgerFilters[0]?.bankName,
        transactionType: ledgerFilters[0]?.transactionType,
        // year: getDate?.fromDate ? ledgerFilters[0]?.years : "",
        // month: getDate?.fromDate ? ledgerFilters[0]?.month : "",
        ...(getDate?.fromDate &&
          ledgerFilters.years && {
            year: ledgerFilters.years,
          }),

        ...(getDate?.fromDate &&
          ledgerFilters.month && {
            month: ledgerFilters.month,
          }),
        page: 1,
        per_page: reportDatapagination?.total,
        rowFilter: {
          $and: [
            {
              companyCode: ledgerFilters[0]?.companyCode,
              postingDate: {
                $gte: getDate?.fromDate,
                $lte: getDate?.toDate,
              },
            },
          ],
        },
      };
    } else if (
      ledgersSteps === 4 &&
      ledgerFilters[0]?.reportType === "EXPENSE"
    ) {
      obj = {
        queryName: "Company_And_Customer_Ledger",
        rowFilter: {
          $and: [
            {
              expenseNameCode: ledgerFilters[0]?.expenseTypeCode,
              companyCode2: ledgerFilters[0]?.companyCode,
              postingDate: {
                $gte: getDate?.fromDate,
                $lte: getDate?.toDate,
              },
            },
          ],
        },
        page: 1,
        per_page: 10,
      };
    }

    // else if(ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES") {
    //      obj = {
    //     queryName: "Company_And_Customer_Ledger",
    //     // filterType: "DATE_RANGE",
    //     // fromDate:ledgerFilters[0]?.fromDate,
    //     // toDate:ledgerFilters[0]?.toDate,
    //     rowFilter: {
    //       $and: [
    //         {
    //            companyCode2: ledgerFilters[0]?.companyCode,
    //           customerCode: ledgerFilters[0]?.customerCode,
    //           year: ledgerFilters[0]?.year,
    //           month: ledgerFilters[0]?.month,
    //            postingDate: {
    //               //  $gte: ledgerFilters[0]?.fromDate,
    //               //  $lte: ledgerFilters[0]?.toDate
    //                $gte: getDate?.fromDate,
    //                $lte: getDate?.toDate
    //             }
    //         },
    //       ],
    //     },
    //     page: 1,
    //     per_page: 10,
    //   };
    //         }

    dispatch(getLedgerList(obj));
    loadCustomerOutStanding();
  };
  //get outStanging amount
  const loadCustomerOutStanding = async () => {
    try {
      const payload = {
        queryName: "Company_And_Customer_Ledger_Outstanding_Amt",
        fromDate: getDate?.fromDate,
        rowFilter: {
          $and: [
            {
              companyCode2: ledgerFilters?.[0]?.companyCode,
              customerCode: ledgerFilters?.[0]?.customerCode,
            },
          ],
        },
      };
      // console.log(">>payload",payload)
      const response = await ItemService.generateCustomerQuery(payload);

      if (response?.status !== 200 || !response?.data) {
        throw new Error(
          response?.message || "Failed to load outstanding amount",
        );
      }
      setOpeningValue(response.data[0]?.outstandingAmount ?? 0);
      // console.log(">>response",response)
    } catch (err) {
      console.error("loadCustomerOutStanding error:", err);
      toast.error("Error loading customer outstanding amount");
    }
  };

  // useEffect(() => {
  //   if (
  //     getDate?.fromDate &&
  //     ledgerFilters?.[0]?.companyCode &&
  //     ledgerFilters?.[0]?.customerCode
  //   ) {
  //     loadCustomerOutStanding();
  //   }
  // }, [
  //   getDate?.fromDate,
  //   ledgerFilters?.[0]?.companyCode,
  //   ledgerFilters?.[0]?.customerCode,
  // ]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                {(ledgersSteps === 3 &&
                  ledgerFilters[0]?.reportType === "SALES" && (
                    <>
                      <h2 className="mainTitle">Sales Ledger</h2>
                      <p className="subText"> Sales Ledger Details</p>
                    </>
                  )) || (
                  <>
                    <h2 className="mainTitle">Ledgers Reports</h2>
                    <p className="subText">Ledgers Reports Details</p>
                  </>
                )}
              </Col>
              {ledgersSteps !== 1 && (
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end align-items-center"
                >
                  <button className="btnBack" onClick={prevStep}>
                    <i className="bi bi-arrow-return-left"></i> Go Back
                  </button>
                </Col>
              )}

              {((ledgersSteps === 3 &&
                (ledgerFilters[0]?.reportType === "SALES" ||
                  ledgerFilters[0]?.reportType === "PURCHASE" ||
                  ledgerFilters[0]?.ledgersQuerName === "Customer")) ||
                (ledgersSteps === 5 &&
                  (ledgerFilters[0]?.reports === "Stock Summary" ||
                    ledgerFilters[0]?.reportType === "CASH_BANK")) ||
                (ledgersSteps === 4 &&
                  ledgerFilters[0]?.reports === "Ledger") ||
                (ledgersSteps === 4 &&
                  ledgerFilters[0]?.reportType === "EXPENSE")) && (
                <>
                  <Col
                    xs={12}
                    md={1}
                    lg={1}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <span
                      className="filterIcon"
                      onClick={() => setFilterShow(!filterShow)}
                    >
                      <i class="bi bi-filter"></i>
                    </span>
                  </Col>
                </>
              )}
            </Row>
            <hr />
            {((ledgersSteps === 3 &&
              (ledgerFilters[0]?.reportType === "SALES" ||
                ledgerFilters[0]?.reportType === "PURCHASE" ||
                ledgerFilters[0]?.ledgersQuerName === "Customer")) ||
              (ledgersSteps === 5 &&
                (ledgerFilters[0]?.reports === "Stock Summary" ||
                  ledgerFilters[0]?.reportType === "CASH_BANK")) ||
              (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") ||
              (ledgersSteps === 4 &&
                ledgerFilters[0]?.reportType === "EXPENSE")) &&
              filterShow && (
                <CommonFilterCustomerV2
                  getfiltereddata={stockAlldetails} //pass datacolumn
                  cancelAction={() => setFilterShow(!filterShow)}
                  onSubmit={(filters) => {
                    handleAdvanceSearchFuncApi(filters);
                    // You can now use the filters here
                  }}
                />
              )}

            {ledgersSteps > 1 && (
              <>
                <StatusCustomReport
                  formInputs={formInputs}
                  getStockDaylyData={tableData}
                  getledgersData={tableData}
                  getToatalCalucation={getToatalCalucation}
                />
                <div className="flex justify-center items-center">
                  {/* <Row className="w-100">
                    <Col
                      xs={4}
                      md={8}
                      lg={8}
                      className="flex justify-start mt-2"
                    >
                      {ledgersSteps === 3 &&
                      ledgerFilters[0]?.reports === "Ledger" ? (
                        <></>
                      ) : (
                        <button className="btnBack" onClick={prevStep}>
                          <i className="bi bi-arrow-return-left"></i> Go Back
                        </button>
                      )}
                    </Col>
                  </Row> */}
                </div>
              </>
            )}

            {((ledgersSteps === 3 &&
              (ledgerFilters[0]?.reportType === "SALES" ||
                ledgerFilters[0]?.reportType === "PURCHASE" ||
                ledgerFilters[0]?.ledgersQuerName === "Customer")) ||
              (ledgersSteps === 5 &&
                (ledgerFilters[0]?.reports === "Stock Summary" ||
                  ledgerFilters[0]?.reportType === "CASH_BANK")) ||
              (ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger") ||
              (ledgersSteps === 4 &&
                ledgerFilters[0]?.reportType === "EXPENSE")) && (
              <>
                <Row>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="From"
                      type="date"
                      name="fromDate"
                      min={1990}
                      value={getDate.fromDate || ""}
                      onChange={onInputChange}
                      //  disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="To"
                      type="date"
                      name="toDate"
                      min={1990}
                      value={getDate.toDate || ""}
                      onChange={onInputChange}
                      //  disabled={true}
                    />
                  </Col>
                  <Col
                    xs={1}
                    md={1}
                    lg={1}
                    className="commTopButtonRightLeftPadding d-flex justify-content-center align-items-center mt-2"
                  >
                    <button className="btn btnTable" onClick={filteByDate}>
                      {" "}
                      <i class="bi bi-search"></i>
                      {/* <i class="bi bi-arrow-return-right mx-2"></i> Go */}
                    </button>
                  </Col>
                </Row>
              </>
            )}

            {ledgersSteps === 3 &&
              ledgerFilters[0]?.reports === "Stock Summary" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={4} lg={4}>
                            <span className="headerTitle">Ledger</span>
                            <span className="subHeaderTitle">
                              Ledger Details
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                title=""
                                columns={productColumns}
                                // data={getprodcutData}
                                data={tableData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                customStyles={{
                                  rows: {
                                    style: {
                                      "&:hover": {
                                        backgroundColor: "#7fc5c4",
                                        color: "#000",
                                        // cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {ledgersSteps === 3 &&
              ledgerFilters[0]?.reportType === "CASH_BANK" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={4} lg={4}>
                            <span className="headerTitle">Ledeger</span>
                            <span className="subHeaderTitle">
                              Ledeger Details
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                title=""
                                columns={cashBankCol}
                                data={cashBankData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                customStyles={{
                                  rows: {
                                    style: {
                                      "&:hover": {
                                        backgroundColor: "#7fc5c4",
                                        color: "#000",
                                        // cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                // progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {ledgersSteps === 3 &&
              ledgerFilters[0]?.reportType === "EXPENSE" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={4} lg={4}>
                            <span className="headerTitle">Ledeger</span>
                            <span className="subHeaderTitle">
                              Expense Ledeger Details
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                title=""
                                columns={expenseCol}
                                data={expenseData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                customStyles={{
                                  rows: {
                                    style: {
                                      "&:hover": {
                                        backgroundColor: "#7fc5c4",
                                        color: "#000",
                                        // cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                // progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            {ledgersSteps === 4 &&
              ledgerFilters[0]?.reportType === "EXPENSE" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={9} lg={9}>
                            <span className="headerTitle"> Ledgers</span>
                            <span className="subHeaderTitle">
                              Expense Ledgers Details
                            </span>
                          </Col>
                          <Col xs={2} md={2} lg={2}>
                            <button
                              className="btn btntable"
                              onClick={() => {
                                // setShowPrint(true);
                                setTimeout(handlePrint, 0);
                              }}
                            >
                              <i class="bi bi-upload"></i> Export
                            </button>
                          </Col>
                          <Col xs={12} md={7} lg={7} className="">
                            <Row>
                              <Col xs={2} md={1} lg={1} className="">
                                <div className="filter">
                                  <span
                                    className="icon hide headerIcon"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="true"
                                  >
                                    <i className="bi bi-three-dots"></i>
                                  </span>
                                  <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                    data-popper-placement="bottom-end"
                                  >
                                    <li className="dropdown-header text-start">
                                      <h6>Menu</h6>
                                    </li>
                                    <li>
                                      {/* <span
                                      className="dropdown-item headerIcon"
                                      onClick={handleDownloadExcel}
                                    >
                                      <i className="bi bi-download mr-2"></i>
                                      Download Excel

                                    </span> */}
                                      <span
                                        onClick={
                                          !isDownloading
                                            ? handleDownloadExcel
                                            : undefined
                                        }
                                        className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                      >
                                        <i className="bi bi-download"></i>
                                        {isDownloading
                                          ? "Downloading..."
                                          : "Download Excel"}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={expenseLedgerCol}
                                // data={tableData}
                                data={tableDataDynamic}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {ledgersSteps === 4 &&
              ledgerFilters[0]?.reportType === "CASH_BANK" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CB</span>
                          </Col>
                          <Col xs={6} md={8} lg={8}>
                            <span className="headerTitle">
                              Cash/Bank Details
                            </span>
                            <span className="subHeaderTitle">
                              Monthly Cash/Bank Deatails
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={cashBankMonthColumns}
                                data={cashBankMonthData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                customStyles={{
                                  rows: {
                                    style: {
                                      "&:hover": {
                                        backgroundColor: "#7fc5c4",
                                        color: "#000",
                                        // cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                conditionalRowStyles={[
                                  {
                                    when: (row) => row.rowType === "opening",
                                    style: {
                                      backgroundColor: "#eef2ff",
                                      fontWeight: "bold",
                                    },
                                  },

                                  {
                                    when: (row) =>
                                      row.rowType === "subtotalRow",
                                    style: {
                                      backgroundColor: "#ecfeff",
                                      fontWeight: "bold",
                                      // borderBottom: "2px solid #000",
                                    },
                                  },
                                  {
                                    when: (row) => row.rowType === "closing",
                                    style: {
                                      backgroundColor: "#ecfeff",
                                      fontWeight: "bold",
                                      // borderBottom: "2px solid #000",
                                    },
                                  },
                                  {
                                    when: (row) => row.rowType === "total",
                                    style: {
                                      backgroundColor: "#f1f5f9",
                                      fontWeight: "bold",
                                      // borderTop: "2px solid #000",
                                    },
                                  },
                                ]}

                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                // progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            {ledgersSteps === 4 &&
              ledgerFilters[0]?.reports === "Stock Summary" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SS</span>
                          </Col>
                          <Col xs={6} md={4} lg={4}>
                            <span className="headerTitle"> Stock Summary</span>
                            <span className="subHeaderTitle">
                              Monthly Stock Summary Details
                            </span>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={stockMonthColumns}
                                // data={getStockMonthlyData}
                                data={tableData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                customStyles={{
                                  rows: {
                                    style: {
                                      "&:hover": {
                                        backgroundColor: "#7fc5c4",
                                        color: "#000",
                                        // cursor: "pointer",
                                      },
                                    },
                                  },
                                }}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            {ledgersSteps === 5 &&
              ledgerFilters[0]?.reportType === "CASH_BANK" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CB</span>
                          </Col>
                          <Col xs={6} md={9} lg={9}>
                            <span className="headerTitle">
                              {" "}
                              CASH/BANK Details
                            </span>
                            <span className="subHeaderTitle">
                              CASH/BANK Details
                            </span>
                          </Col>
                          <Col xs={1} md={1} lg={1}>
                            <button
                              className="btn btntable"
                              onClick={() => {
                                // setShowPrint(true);
                                setTimeout(handlePrint, 0);
                              }}
                            >
                              <i class="bi bi-upload"></i> Export
                            </button>
                          </Col>

                          <Col xs={12} md={7} lg={7} className="">
                            <Row>
                              <Col xs={2} md={1} lg={1} className="">
                                <div className="filter">
                                  <span
                                    className="icon hide headerIcon"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="true"
                                  >
                                    <i className="bi bi-three-dots"></i>
                                  </span>
                                  <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                    data-popper-placement="bottom-end"
                                  >
                                    <li className="dropdown-header text-start">
                                      <h6>Menu</h6>
                                    </li>
                                    <li>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                      <span
                                        onClick={
                                          !isDownloading
                                            ? handleDownloadExcel
                                            : undefined
                                        }
                                        className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                      >
                                        <i className="bi bi-download"></i>
                                        {isDownloading
                                          ? "Downloading..."
                                          : "Download Excel"}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                // columns={cashBankAlldetails}
                                columns={getcashBankAlldetails}
                                // data={tableData}
                                data={tableDataDynamic}
                                // data={getCashData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                // paginationTotalRows={
                                //   reportDatapagination?.total
                                // }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            {ledgersSteps === 5 &&
              ledgerFilters[0]?.reports === "Stock Summary" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SS</span>
                          </Col>
                          <Col xs={6} md={8} lg={8}>
                            <span className="headerTitle"> Stock Summary</span>
                            <span className="subHeaderTitle">
                              Stock Summary Details
                            </span>
                          </Col>
                          <Col
                            xs={2}
                            md={2}
                            lg={2}
                            className="d-flex justify-content-end"
                          >
                            <button
                              className="btn btntable"
                              onClick={() => {
                                setTimeout(handlePrint, 0); // ensure component mounts first
                              }}
                            >
                              <i class="bi bi-upload"></i> Export
                            </button>
                          </Col>

                          <Col xs={12} md={7} lg={7} className="">
                            <Row>
                              <Col xs={2} md={1} lg={1} className="">
                                <div className="filter">
                                  <span
                                    className="icon hide headerIcon"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="true"
                                  >
                                    <i className="bi bi-three-dots"></i>
                                  </span>
                                  <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                    data-popper-placement="bottom-end"
                                  >
                                    <li className="dropdown-header text-start">
                                      <h6>Menu</h6>
                                    </li>
                                    <li>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                      <span
                                        onClick={
                                          !isDownloading
                                            ? handleDownloadExcel
                                            : undefined
                                        }
                                        className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                      >
                                        <i className="bi bi-download"></i>
                                        {isDownloading
                                          ? "Downloading..."
                                          : "Download Excel"}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={stockAlldetails}
                                data={tableData}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {/* customer ledger report */}
            {ledgersSteps === 3 &&
              ledgerFilters[0]?.ledgersQuerName === "Customer" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={8} lg={8}>
                            <span className="headerTitle">Ledgers</span>
                            <span className="subHeaderTitle">
                              Ledgers Details
                            </span>
                          </Col>
                          <Col
                            xs={2}
                            md={2}
                            lg={2}
                            className="d-flex justify-content-end"
                          >
                            <button
                              className="btn btntable"
                              onClick={() => {
                                setTimeout(handlePrint, 0); // ensure component mounts first
                              }}
                            >
                              <i class="bi bi-upload"></i> Export
                            </button>
                          </Col>
                          <Col xs={12} md={7} lg={7} className="">
                            <Row>
                              <Col xs={2} md={1} lg={1} className="">
                                <div className="filter">
                                  <span
                                    className="icon hide headerIcon"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="true"
                                  >
                                    <i className="bi bi-three-dots"></i>
                                  </span>
                                  <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                    data-popper-placement="bottom-end"
                                  >
                                    <li className="dropdown-header text-start">
                                      <h6>Menu</h6>
                                    </li>
                                    <li>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                      <span
                                        onClick={
                                          !isDownloading
                                            ? handleDownloadExcel
                                            : undefined
                                        }
                                        className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                      >
                                        <i className="bi bi-download"></i>
                                        {isDownloading
                                          ? "Downloading..."
                                          : "Download Excel"}
                                      </span>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={() =>
                                          exportDataTableToExcel(
                                            tableData, // 🔹 your table data
                                            getledgersColumn, // 🔹 your column config
                                            "Stock_Summary.xlsx" // 🔹 export file name
                                          )
                                        }
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={getledgersColumn}
                                // data={getledgersData}
                                // data={tableData}
                                data={tableDataDynamic}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                                conditionalRowStyles={[
                                  {
                                    when: (row) => row.rowType === "opening",
                                    style: {
                                      backgroundColor: "#eef2ff",
                                      fontWeight: "bold",
                                    },
                                  },

                                  {
                                    when: (row) =>
                                      row.rowType === "subtotalRow",
                                    style: {
                                      backgroundColor: "#ecfeff",
                                      fontWeight: "bold",
                                      // borderBottom: "2px solid #000",
                                    },
                                  },
                                  {
                                    when: (row) => row.rowType === "closing",
                                    style: {
                                      backgroundColor: "#ecfeff",
                                      fontWeight: "bold",
                                      // borderBottom: "2px solid #000",
                                    },
                                  },
                                  {
                                    when: (row) => row.rowType === "total",
                                    style: {
                                      backgroundColor: "#f1f5f9",
                                      fontWeight: "bold",
                                      // borderTop: "2px solid #000",
                                    },
                                  },
                                ]}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {/* Print out for all */}
            <div className="d-none">
              <PrintCustomerLedger
                ref={contentRef}
                getDate={getDate}
                balanceData={{
                  openingRow,
                  subtotalRow,
                  totalRow,
                  closingRow,
                }}
              />
            </div>

            {/* <div className="d-block">
              <PrintCustomerLedger
                ref={contentRef}
                getDate={getDate}
                balanceData={{
                  openingRow,
                  subtotalRow,
                  totalRow,
                  closingRow,
                }}
              />
            </div> */}

            {/* Sales ledger report */}
            {ledgersSteps === 3 && ledgerFilters[0]?.reportType === "SALES" && (
              <>
                <div className="accordion mt-2" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={6} md={9} lg={9}>
                          <span className="headerTitle">Sales Ledger</span>
                          <span className="subHeaderTitle">
                            Sales Ledgers Details
                          </span>
                        </Col>
                        <Col
                          xs={2}
                          md={2}
                          lg={2}
                          className="d-flex justify-content-center"
                        >
                          <button
                            className="btn btntable"
                            onClick={() => {
                              // setShowPrint(true);
                              setTimeout(handlePrint, 0);
                            }}
                          >
                            <i class="bi bi-upload"></i> Export
                          </button>
                        </Col>

                        <Col xs={12} md={7} lg={7} className="">
                          <Row>
                            <Col xs={2} md={1} lg={1} className="">
                              <div className="filter">
                                <span
                                  className="icon hide headerIcon"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="true"
                                >
                                  <i className="bi bi-three-dots"></i>
                                </span>
                                <ul
                                  className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                  data-popper-placement="bottom-end"
                                >
                                  <li className="dropdown-header text-start">
                                    <h6>Menu</h6>
                                  </li>
                                  <li>
                                    {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                    <span
                                      onClick={
                                        !isDownloading
                                          ? handleDownloadExcel
                                          : undefined
                                      }
                                      className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                    >
                                      <i className="bi bi-download"></i>
                                      {isDownloading
                                        ? "Downloading..."
                                        : "Download Excel"}
                                    </span>
                                    {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={() =>
                                          exportDataTableToExcel(
                                            tableData, // 🔹 your table data
                                            getledgersColumn, // 🔹 your column config
                                            "Stock_Summary.xlsx" // 🔹 export file name
                                          )
                                        }
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                  </li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12} className="ledger-table">
                            <DataTable
                              title=""
                              columns={salesLedgerCol}
                              data={salesLedgerTableDataDynamic}
                              // data={tableData}
                              // progressPending={reportData?.status}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              paginationServer
                              paginationPerPage={10}
                              paginationTotalRows={reportDatapagination?.total}
                              onChangeRowsPerPage={handlePerRowsChange}
                              onChangePage={handlePageChange}
                              progressPending={loading}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* Purchase ledger report */}
            {ledgersSteps === 3 &&
              ledgerFilters[0]?.reportType === "PURCHASE" && (
                <>
                  <div className="accordion mt-2" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible
                                  ? "bi-chevron-down"
                                  : "bi-chevron-right"
                              }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">L</span>
                          </Col>
                          <Col xs={6} md={9} lg={9}>
                            <span className="headerTitle">PURCHASE</span>
                            <span className="subHeaderTitle">
                              PURCHASE Ledgers Details
                            </span>
                          </Col>
                          <Col xs={1} md={1} lg={1}>
                            <button
                              className="btn btntable"
                              onClick={() => {
                                // setShowPrint(true);
                                setTimeout(handlePrint, 0);
                              }}
                            >
                              <i class="bi bi-upload"></i> Export
                            </button>
                          </Col>
                          <Col xs={12} md={7} lg={7} className="">
                            <Row>
                              <Col xs={2} md={1} lg={1} className="">
                                <div className="filter">
                                  <span
                                    className="icon hide headerIcon"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="true"
                                  >
                                    <i className="bi bi-three-dots"></i>
                                  </span>
                                  <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                    data-popper-placement="bottom-end"
                                  >
                                    <li className="dropdown-header text-start">
                                      <h6>Menu</h6>
                                    </li>
                                    <li>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={handleDownloadExcel}
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                      <span
                                        onClick={
                                          !isDownloading
                                            ? handleDownloadExcel
                                            : undefined
                                        }
                                        className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                      >
                                        <i className="bi bi-download"></i>
                                        {isDownloading
                                          ? "Downloading..."
                                          : "Download Excel"}
                                      </span>
                                      {/* <span
                                        className="dropdown-item headerIcon"
                                        onClick={() =>
                                          exportDataTableToExcel(
                                            tableData, // 🔹 your table data
                                            getledgersColumn, // 🔹 your column config
                                            "Stock_Summary.xlsx" // 🔹 export file name
                                          )
                                        }
                                      >
                                        <i className="bi bi-download mr-2"></i>
                                        Download Excel
                                      </span> */}
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${
                          isCardVisible ? "visible" : ""
                        }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="ledger-table"
                            >
                              <DataTable
                                title=""
                                columns={purchaseLedgerCol}
                                // data={tableData}
                                data={purchaseLedgerTableDataDynamic}
                                // data={tableDataDynamic}
                                // progressPending={reportData?.status}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                paginationServer
                                paginationPerPage={10}
                                paginationTotalRows={
                                  reportDatapagination?.total
                                }
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                progressPending={loading}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            {ledgersSteps === 4 && ledgerFilters[0]?.reports === "Ledger" && (
              <>
                <div className="accordion mt-2" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-down"
                                : "bi-chevron-right"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">L</span>
                        </Col>
                        <Col xs={6} md={8} lg={8}>
                          <span className="headerTitle"> Ledgers</span>
                          <span className="subHeaderTitle">
                            Ledgers Details
                          </span>
                        </Col>
                        <Col xs={2} md={2} lg={2}>
                          <button
                            className="btn btntable"
                            onClick={() => {
                              // setShowPrint(true);
                              setTimeout(handlePrint, 0);
                            }}
                          >
                            <i class="bi bi-upload"></i> Export
                          </button>
                        </Col>
                        <Col xs={12} md={7} lg={7} className="">
                          <Row>
                            <Col xs={2} md={1} lg={1} className="">
                              <div className="filter">
                                <span
                                  className="icon hide headerIcon"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="true"
                                >
                                  <i className="bi bi-three-dots"></i>
                                </span>
                                <ul
                                  className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                  data-popper-placement="bottom-end"
                                >
                                  <li className="dropdown-header text-start">
                                    <h6>Menu</h6>
                                  </li>
                                  <li>
                                    {/* <span
                                      className="dropdown-item headerIcon"
                                      onClick={handleDownloadExcel}
                                    >
                                      <i className="bi bi-download mr-2"></i>
                                      Download Excel

                                    </span> */}
                                    <span
                                      onClick={
                                        !isDownloading
                                          ? handleDownloadExcel
                                          : undefined
                                      }
                                      className={`dropdown-item headerIcon flex items-center gap-2 px-3 py-2 rounded-md transition 
          ${
            isDownloading
              ? "opacity-50 cursor-not-allowed pointer-events-none"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
                                    >
                                      <i className="bi bi-download"></i>
                                      {isDownloading
                                        ? "Downloading..."
                                        : "Download Excel"}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12} className="ledger-table">
                            <DataTable
                              title=""
                              columns={getledgersColumn}
                              // data={getledgersData}
                              data={tableData}
                              // progressPending={reportData?.status}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              paginationServer
                              paginationPerPage={10}
                              paginationTotalRows={reportDatapagination?.total}
                              onChangeRowsPerPage={handlePerRowsChange}
                              onChangePage={handlePageChange}
                              progressPending={loading}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {ledgersSteps === 3 && ledgerFilters[0]?.reports === "Ledger" && (
              <>
                {/*  <Col
                  xs={12}
                  md={12}
                  lg={12}
                  className="flex justify-start align-center mb-2"
                >
                  <button className="btnBack" onClick={prevStep}>
                    <i className="bi bi-arrow-return-left"></i> Go Back
                  </button>
                </Col> */}
                <Col xs={12} md={12} lg={12}>
                  <Row>
                    <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className=" mb-2 d-flex justify-content-center align-items-center px-2 mt-2"
                    >
                      <div className="company-card">
                        <div className="company-header fs-4">Ledgers</div>
                        <div className="company-body">
                          {ledgerOptions.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => handleClickLedgers(item)}
                              className="company-item"
                            >
                              {item.name}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                    {/* <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className=" mb-2 d-flex justify-content-center align-items-start px-2"
                    >
                      <div className="company-card w-[400px] h-[450px]">
                        <div className="company-header fs-4">
                          Customer Ledger
                        </div>
                        <div className="company-body px-2">
                          <ComboboxField
                            label="Customer Name "
                            placeholder="Select Customer"
                            data={getCustomer}
                            id="customerName"
                            iconClassName="dropdownIcon"
                            name="customerName"
                            code="customerCode"
                            description="customerNameDesc"
                            setValue={formInputs?.customerName || ""}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.customerName}
                          />
                        </div>
                        <div className="flex items-center justify-center">
                          <button
                            className="btnTable w-25"
                            onClick={handleClickCustomerLedger}
                            // disabled ={getcustomerLedgerButton}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
              </>
            )}

            {ledgersSteps === 2 && (
              <>
                <Col xs={12} md={12} lg={12} className="mt-2">
                  <Row>
                    <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className="commLeftRightPadding mb-2 d-flex justify-content-center align-items-start"
                    >
                      <div className="company-card h-[400px]">
                        <div className="company-header fs-4">Ledger</div>
                        <div className="company-body">
                          {reports.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => handleCardClick(item)}
                              className="company-item"
                            >
                              {item.name}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className=" mb-2 d-flex justify-content-center align-items-start px-2"
                    >
                      <div className="company-card w-[400px] h-[400px]">
                        <div className="company-header fs-4">
                          Customer/Vendor/Employee Ledger
                        </div>
                        <div className="company-body px-2">
                          <ComboboxField
                            label="Name"
                            placeholder="Select"
                            data={getCustomer}
                            id="customerName"
                            iconClassName="dropdownIcon"
                            name="customerName"
                            code="customerCode"
                            description="customerNameDesc"
                            setValue={formInputs?.customerName || ""}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.customerName}
                          />
                        </div>
                        <div className="flex items-center justify-center">
                          <button
                            className="btnTable w-25"
                            onClick={handleClickCustomerLedger}
                            disabled={getDisabelCustomer}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </>
            )}
            <div className="flex justify-center items-center h-[60vh]">
              <Row className="w-100">
                {ledgersSteps === 1 && (
                  <Col
                    xs={12}
                    md={{ offset: 4, spam: 2 }}
                    lg={4}
                    className="commLeftRightPadding mb-2 d-flex justify-content-center align-items-center"
                  >
                    <div className="company-card">
                      <div className="company-header fs-4">Company</div>
                      <div className="company-body">
                        {getCompanyCode?.map((item) => (
                          <div
                            key={item.id}
                            onClick={() => handleCompanyClick(item)}
                            className="company-item"
                          >
                            {item?.description}
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CustomReportV2;
